/* lua.js generated code 0.3.0 */

require("hecore/rpc")
require("clover/net/Http")
var kUserLogin = true
var AppController = AppController || table()
if (__IOS) {
    AppController = oc.HeAppController
}

// LoginHttp ---------------------------------------------------------
LoginHttp = xClass("LoginHttp", HttpBase)
LoginHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("game login fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("game login success")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.login, null, loadCallback, rpc.SendingPriority.kHigh, true)
}
// FriendHttp ---------------------------------------------------------
FriendHttp = xClass("FriendHttp", HttpBase)
FriendHttp.prototype.load = function (friendIds, strategy) {
    var self = this
    assert(type(friendIds) === "table", "friendIds not a table")
    var context = self
    strategy = strategy || 0
    friendIds = friendIds || table()
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("get friends fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("get friends success")
            context.onLoadingComplete(data)
        }
    }
    let friends = $tableToArray(friendIds)
    delete friends.__isLuaTable
    self.request(kHttpEndPoints.friends, table([1, "friendIds", friends], [1, "strategy", strategy]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// AnimalFriendsHttp ---------------------------------------------------------
AnimalFriendsHttp = xClass("AnimalFriendsHttp", HttpBase)
AnimalFriendsHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("get animal friends fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("get animal friends success")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.animalFriends, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
GetFriendsHttp = xClass("GetFriendsHttp", HttpBase)
GetFriendsHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("get friends id fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("get friends id success ! ")
            if (data) {
                if (data.friendIds) {
                    for (var index in data.friendIds) {
                        var element = data.friendIds[index];
                        if (element != null) {
                            data.friendIds[index] = tonumber(element)
                        }
                    }
                }
                UserManager.getInstance().friendIds = data.friendIds || table()
            }
            context.onLoadingComplete(data)
        }
    }
    var parameters = table()
    if (__IOS_FB) {
        parameters.openId = Localhost.getInstance().readCurrentUserData().openId
        parameters.accessToken = FacebookProxy.getInstance().accessToken()
        cc.log("openId=" + tostring(parameters.openId) + ",accessToken=" + tostring(parameters.accessToken))
    }
    if (window.META.platform === XcloverPlatform.qq ||
        META.platform == XcloverPlatform.weixin) {
        GameProxy.getInstance().getLoginInfo(function (data) {
            parameters.openid = data.openid
            parameters.openkey = data.openkey
            parameters.platform = window.META.user.platform
            self.request(kHttpEndPoints.getFriends, parameters, loadCallback, rpc.SendingPriority.kHigh, false)
        })
    } else {
        self.request(kHttpEndPoints.getFriends, parameters, loadCallback, rpc.SendingPriority.kHigh, false)
    }
}
// GetUnlockFriendHttp ---------------------------------------------------------
GetUnlockFriendHttp = xClass("GetUnlockFriendHttp", HttpBase)
GetUnlockFriendHttp.prototype.load = function () {
    var self = this
    var context = self
    var unlockFriendCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("get unlock friend fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("get unlock friend success")
            UserManager.getInstance().unLockInfo = data.unLockInfo
            context.onLoadingComplete()
        }
    }
    self.request(kHttpEndPoints.getUnLockFriend, null, unlockFriendCallback, rpc.SendingPriority.kHigh, false)
}
// QueryUserHttp ---------------------------------------------------------
QueryUserHttp = xClass("QueryUserHttp", HttpBase)
QueryUserHttp.prototype.load = function (code) {
    var self = this
    var context = self
    function loadCallback(endPoint, data, err) {
        if (err) {
            he_log_info("QueryUserHttp, err:" + err)
            context.onLoadingError(err)
        } else {
            he_log_info("QueryUserHttp success")
            context.onLoadingComplete(data)
        }
    }
    let data = {
        // "type": 1,
        "code": code
    }
    // self.request(kHttpEndPoints.queryUser, table([1, "code", code]), loadCallback, rpc.SendingPriority.kHigh, false)
    self.request(kHttpEndPoints.queryUser, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// queryUidByPhones ---------------------------------------------------------
QueryUidByPhonesHttp = xClass("QueryUidByPhonesHttp", HttpBase)
QueryUidByPhonesHttp.prototype.load = function (phoneNumbers) {
    var self = this
    var context = self
    function loadCallback(endPoint, data, err) {
        if (err) {
            he_log_info("QueryUidByPhonesHttp, err:" + err)
            context.onLoadingError(err)
        } else {
            he_log_info("QueryUidByPhonesHttp success")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.queryUidByPhones, table([1, "phoneNumbers", phoneNumbers]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// RequestFriend ---------------------------------------------------------
RequestFriendHttp = xClass("RequestFriendHttp", HttpBase)
RequestFriendHttp.prototype.load = function (code, uid) {
    var self = this
    var context = self
    function loadCallback(endPoint, data, err) {
        if (err) {
            he_log_info("RequestFriendHttp fail, err:" + err)
            context.onLoadingError(err)
        } else {
            he_log_info("RequestFriendHttp success")
            context.onLoadingComplete()
        }
    }
    self.request(kHttpEndPoints.requestFriend, table([1, "inviteCode", code], [1, "friendUid", uid]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetLevelScoreRankHttp ---------------------------------------------------------
GetLevelScoreRankHttp = xClass("GetLevelScoreRankHttp", HttpBase)
GetLevelScoreRankHttp.prototype.load = function (levelId, pageStart, pageEnd) {
    var self = this
    assert(levelId != null, "levelId must not a nil")
    assert(pageStart != null, "pageStart must not a nil")
    assert(pageEnd != null, "pageEnd must not a nil")
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("getLevelScoreRank fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("getLevelScoreRank success")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getLevelScoreRank, table(
        [1, "levelId", levelId],
        [1, "pageStart", pageStart],
        [1, "pageEnd", pageEnd]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetLevelTopHttp ---------------------------------------------------------
GetLevelTopHttp = xClass("GetLevelTopHttp", HttpBase)
GetLevelTopHttp.prototype.load = function (levelId) {
    var self = this
    // if not kUserLogin then return self:onLoadingError(ZooErrorCode.kNotLoginError) end
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("getLevelTop fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("getLevelTop success")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getLevelTop, table([1, "levelId", levelId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// EndLadyBugTask ---------------------------------------------------------
EndLadyBugTask = xClass("EndLadyBugTask", HttpBase)
EndLadyBugTask.prototype.load = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    assert($len(table([2, __VA_ARG])) === 0)
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("end lady bug task error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("end lady bug task success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.endLadyBugTask, null, loadCallback, rpc.SendingPriority.kHigh, false)
}
// FinishChildLadyBugTask ---------------------------------------------------------
FinishChildLadyBugTask = xClass("FinishChildLadyBugTask", HttpBase)
FinishChildLadyBugTask.prototype.load = function (taskId) {
    var __VA_ARG = $slice(arguments, 1)
    var self = this
    assert(type(taskId) === "number")
    assert($len(table([2, __VA_ARG])) === 0)
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("finish child lady bug task taskId:" + taskId + " error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("finish child lady bug task taskId:" + taskId + " success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.finishChildLadyBugTask, table([1, "taskId", taskId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetInvitedFriendsUserInfo ---------------------------------------------------------
GetInvitedFriendsUserInfo = xClass("GetInvitedFriendsUserInfo", HttpBase)
GetInvitedFriendsUserInfo.prototype.load = function (invitedFriendsInfo) {
    var self = this
    cc.log("this debug GetInvitedFriendsUserInfo:load")
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var friendIds = table()
    for (var k in invitedFriendsInfo) {
        var v = invitedFriendsInfo[k]
        if (tonumber(v.friendUid) !== 0 && v.invite === true) {
            table.insert(friendIds, tonumber(v.friendUid))
        }
    }
    function loadCallback(endPoint, data, err) {
        if (err) {
            he_log_info("GetInvitedFriendsUserInfo: error: " + err)
            self.onLoadingError(err)
        } else {
            cc.log("this debug loadCallback sucess")
            FriendManager.getInstance().syncFromLuaForInvitedFriends(data.users, data.profiles)
            self.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.friends, table([1, "refresh", refresh], [1, "friendIds", friendIds]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetInviteFriendsInfo ---------------------------------------------------------
GetInviteFriendsInfo = xClass("GetInviteFriendsInfo", HttpBase)
GetInviteFriendsInfo.prototype.load = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    assert($len(table([2, __VA_ARG])) === 0)
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("get invite frinds info error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("get invite friends info success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getInviteFriendsInfo, null, loadCallback, rpc.SendingPriority.kHigh, false)
}
// RespRequest ---------------------------------------------------------
// <property code="action" type="int" desc="用户操作 1：同意帮助，2：忽略" />
// <property code="id" type="int" desc="请求id" />
RespRequest = xClass("RespRequest", HttpBase)
RespRequest.prototype.load = function (id, action) {
    var self = this
    cc.log("RespOpCheckTask:" + id + ":" + action)
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("RespRequest error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("RespRequest success !")
            UserManager.getInstance().removeRequestInfo(id)
            UserManager.getInstance().requestNum = UserManager.getInstance().requestNum - 1
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.respRequest, table([1, "id", id], [1, "action", action]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// NewUserEnergy ---------------------------------------------------------
// 
NewUserEnergy = xClass("NewUserEnergy", HttpBase)
NewUserEnergy.prototype.load = function () {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("Request error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("Request success !")
            context.onLoadingComplete()
        }
    }
    self.transponder.call(kHttpEndPoints.newUserEnergy, null, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// GetUserHttp ---------------------------------------------------------
// 
GetUserHttp = xClass("GetUserHttp", HttpBase)
GetUserHttp.prototype.load = function (data, callback) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetUserHttp error: " + err)
            context.onLoadingError(err)
        } else {
            // he_log_info("GetUserHttp success !")
            context.onLoadingComplete(data)
            // callback &&callback(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getUser, null, loadCallback, rpc.SendingPriority.kHigh, false)
    //self.transponder.call(ApiList.user, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

GetPropsHttp = xClass("getPropsHttp", HttpBase)
GetPropsHttp.prototype.load = function (data, callback) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetPropsHttp error: " + err)
            context.onLoadingError(err)
        } else {
            // he_log_info("GetPropsHttp success !")
            context.onLoadingComplete(data)
            // callback &&callback(data)
        }
    }
     self.transponder.call(kHttpEndPoints.getProps, null, loadCallback, rpc.SendingPriority.kHigh, false)
}

/**
 * 获取星星状态接口
 */
GetStarChestInfoHttp = xClass("getStarChestInfoHttp", HttpBase)
GetStarChestInfoHttp.prototype.load = function (data, callback) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetStarChestInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            // he_log_info("GetStarChestInfoHttp success !")
            context.onLoadingComplete(data)
            // callback &&callback(data)
        }
    }
     self.transponder.call(kHttpEndPoints.getStarChestInfo, null, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// GetLeftAskInfoHttp ---------------------------------------------------------
// 
GetLeftAskInfoHttp = xClass("GetLeftAskInfoHttp", HttpBase)
GetLeftAskInfoHttp.prototype.load = function (uid) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetLeftAskInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetLeftAskInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getLeftAskInfos, table([1, "uids", uid]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// GetRequestInfoHttp ---------------------------------------------------------
// 
GetRequestInfoHttp = xClass("GetRequestInfoHttp", HttpBase)
GetRequestInfoHttp.prototype.load = function () {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetRequestInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetRequestInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getRequestInfos, table([1, "uilds", uid]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// GetRequestNumHttp ---------------------------------------------------------
// 
GetRequestNumHttp = xClass("GetRequestNumHttp", HttpBase)
GetRequestNumHttp.prototype.load = function () {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetRequestNumHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetRequestNumHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var userbody = table([1, "curMd5", ResourceLoader.getCurVersion()], [1, "pName", _G.packageName])
    if (he.StartupConfig.getInstance().isSmallRes()) {
        userbody.mini = 1
    } else {
        userbody.mini = 0
    }
    //推送召回 前端向后端发送流失状态
    userbody.lostType = RecallManager.getInstance().getRecallRewardState()
    self.transponder.call(kHttpEndPoints.getRequestNum, userbody, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// IgnoreFreegift ---------------------------------------------------------
// 
IgnoreFreegiftHttp = xClass("IgnoreFreegiftHttp", HttpBase)
IgnoreFreegiftHttp.prototype.load = function (messageId) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("IgnoreFreegiftHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("IgnoreFreegiftHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.ignoreFreegift, table([1, "id", messageId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetMsgListHttp ---------------------------------------------------------------
GetMsgListHttp = xClass("GetMsgListHttp", HttpBase)
GetMsgListHttp.prototype.load = function (msgType, isSysMsg) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetMsgListHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetMsgListHttp success !")
            context.onLoadingComplete(data)
        }
    }
    let data = {
        "category": msgType,
        "sysMsg": isSysMsg
    }
    self.request(kHttpEndPoints.getMsgList, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// EnterMainSceneHttp ---------------------------------------------------------------
EnterMainSceneHttp = xClass("EnterMainSceneHttp", HttpBase)
EnterMainSceneHttp.prototype.load = function (msgType) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("EnterMainSceneHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("EnterMainSceneHttp success !")
            context.onLoadingComplete(data)
        }
    }
    // var userbody = table([1, "curMd5", ResourceLoader.getCurVersion()], [1, "pName", _G.packageName])
    var userbody = table()
    if (__use_small_res) {
        userbody.mini = 1
    } else {
        userbody.mini = 0
    }
    if (__IOS) {
        userbody.idfa = AppController.getAdvertisingIdentifier() || ""
    } else if (__ANDROID) {
        userbody.idfa = he.MetaInfo.getInstance().getUdid()
        userbody.smsPayMd5 = GameProxy.getInstance().getDecisionScriptMd5()
    }
    self.request(kHttpEndPoints.enterMainScene, userbody, loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetSysMsgListHttp ---------------------------------------------------------------
GetSysMsgListHttp = xClass("GetSysMsgListHttp", HttpBase)
GetSysMsgListHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetSysMsgListHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetSysMsgListHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var params = table()
    if (__IOS) {
        params.idfa = AppController.getAdvertisingIdentifier() || ""
    } else if (__ANDROID) {
        params.idfa = he.MetaInfo.getInstance().getUdid()
    }
    self.request(kHttpEndPoints.getSysMsgList, params, loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetWantFreeGiftInfosHttp ---------------------------------------------------------------
GetWantFreeGiftInfosHttp = xClass("GetWantFreeGiftInfosHttp", HttpBase)
GetWantFreeGiftInfosHttp.prototype.load = function (uids) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetWantFreeGiftInfosHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetWantFreeGiftInfosHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getWantFreeGiftInfos, table([1, "uids", uids]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetCouponListHttp ------------------------------------------------------
GetCouponListHttp = xClass("GetCouponListHttp", HttpBase)
GetCouponListHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetCouponListHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetCouponListHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getCouponList, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// updateConfigFromServer ---------------------------------------------------------
// 
UpdateConfigFromServerHttp = xClass("UpdateConfigFromServerHttp", HttpBase)
UpdateConfigFromServerHttp.prototype.load = function () {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("updateConfigFromServer error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("updateConfigFromServer success !")
            self.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.updateConfigFromServer, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
//----------
//- queryQihooOrder
//-----------
QueryQihooOrderHttp = xClass("QueryQihooOrderHttp", HttpBase)
QueryQihooOrderHttp.prototype.load = function (orderId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("QueryQihooOrderHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("QueryQihooOrderHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.queryQihooOrder, table([1, "orderId", orderId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
ExtraConnectHttp = xClass("ExtraConnectHttp", HttpBase)
ExtraConnectHttp.prototype.load = function (openId, accessToken, snsPlatform, snsName) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("QQConnectHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("QQConnectHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var connectProtocol = "extraConnect"
    var params = table(
        [1, "openId", openId],
        [1, "accessToken", accessToken],
        [1, "snsPlatform", snsPlatform],
        [1, "snsName", snsName]
    )
    self.transponder.call(connectProtocol, params, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// Connect ---------------------------------------------------------
// 
ConnectHttp = xClass("ConnectHttp", HttpBase)
ConnectHttp.prototype.load = function (openId, accessToken, unionId, snsPlatform, snsName) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ConnectHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ConnectHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var connectProtocol = "connect"
    var idfa = ""
    if (__IOS) {
        idfa = AppController.getAdvertisingIdentifier() || ""
    } else if (__ANDROID) {
        idfa = kDeviceID
    }
    var imei = ""
    if (__IOS || __ANDROID) {
        imei = he.MetaInfo.getInstance().getImei()
    }
    var params = table(
        [1, "openId", openId],
        [1, "idfa", idfa],
        [1, "imei", imei],
        [1, "accessToken", accessToken],
        [1, "snsPlatform", snsPlatform],
        [1, "snsName", snsName],
        [1, "unionId", unionId],
        [1, "name", snsName]
    )
    self.transponder.call(connectProtocol, params, loadCallback, rpc.SendingPriority.kHigh, false)
}
//rebinding
RebindingHttp = xClass("RebindingHttp", HttpBase)
RebindingHttp.prototype.load = function (snsName, openId) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("RebindingHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("RebindingHttp success !")
            self.onLoadingComplete(data)
        }
    }
    var connectProtocol = "reBinding"
    self.transponder.call(connectProtocol, table([1, "snsName", snsName], [1, "openId", openId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// PreQQConnectHttp ---------------------------------------------------------
// 
PreConnectHttp = xClass("PreConnectHttp", HttpBase)
PreConnectHttp.prototype.load = function (openId, accessToken, unionId, haveSyncCache, snsPlatform, snsName) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ConnectHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ConnectHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var connectProtocol = "preConnect"
    var idfa = ""
    if (__IOS) {
        idfa = AppController.getAdvertisingIdentifier() || ""
    } else if (__ANDROID) {
        idfa = kDeviceID
    }
    var imei = ""
    if (__IOS || __ANDROID) {
        imei = he.MetaInfo.getInstance().getImei()
    }
    // print("openId="..openId..",accessToken="..accessToken)
    var params = table(
        [1, "openId", openId],
        [1, "idfa", idfa],
        [1, "imei", imei],
        [1, "accessToken", accessToken],
        [1, "snsPlatform", snsPlatform],
        [1, "hasCache", haveSyncCache],
        [1, "snsName", snsName],
        [1, "unionId", unionId]
    )
    self.transponder.call(connectProtocol, params, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// SyncSnsFriendHttp ----------------------------------------------------
// 
SyncSnsFriendHttp = xClass("SyncSnsFriendHttp", HttpBase)
SyncSnsFriendHttp.prototype.load = function (friendOpenIds, openId, accessToken) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("syncSnsFriend fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("syncSnsFriend success")
            if (data.users && type(data.users) === "table") {
                FriendManager.getInstance().syncFromLua(data.users, data.profiles, data.snsFriendIds)
                Localhost.getInstance().flushCurrentFriendsData()
            }
            context.onLoadingComplete(data)
        }
    }
    var params = table(
        [1, "friendOpenIds", friendOpenIds],
        [1, "openId", openId],
        [1, "openKey", accessToken]
    )
    if (__ANDROID && _G.sns_token) {
        params.snsPlatform = PlatformConfig.getPlatformAuthName()
    }
    self.transponder.call(kHttpEndPoints.syncSnsFriend, params, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// GetNearbyHttp ----------------------------------------------------
// 
// <request>
// 	<property code="longitude" type="double" desc="经度"/>
// 	<property code="latitude" type="double" desc="纬度"/>
// </request>
// <response>
// 	<list code="users" ref="User" desc="用户列表"/>
// 	<list code="profiles" ref="Profile" desc="用户头像列表"/>
// </response>
GetNearbyHttp = xClass("GetNearbyHttp", HttpBase)
GetNearbyHttp.prototype.load = function (longitude, latitude) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetNearbyHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetNearbyHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getNearby, table([1, "longitude", longitude], [1, "latitude", latitude]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// GetNearbyHttpV2 ----------------------------------------------------
// 新版附近的人
// <request>
// 	<property code="longitude" type="double" desc="经度"/>
// 	<property code="latitude" type="double" desc="纬度"/>
// </request>
// <response>
// 	<list code="users" ref="User" desc="用户列表"/>
// 	<list code="profiles" ref="Profile" desc="用户头像列表"/>
// </response>
GetNearbyHttpV2 = xClass("GetNearbyHttpV2", HttpBase)
GetNearbyHttpV2.prototype.load = function (longitude, latitude) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetNearbyHttpV2 error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetNearbyHttpV2 success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getNearbyV2, table([1, "longitude", longitude], [1, "latitude", latitude]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// GetNearbyHttpV2 ----------------------------------------------------
// <request>
// </request>
// <response>
// 	<list code="strangers" ref="Stranger" desc=""/>
// </response>
FriendLinkHttp = xClass("FriendLinkHttp", HttpBase)
FriendLinkHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("FriendLinkHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("FriendLinkHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.frdLink, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// SendLocationHttp ----------------------------------------------------
// 
// <request>
// 	<property code="longitude" type="double" desc="经度"/>
// 	<property code="latitude" type="double" desc="纬度"/>
// </request>
// <response>
// </response>
SendLocationHttp = xClass("SendLocationHttp", HttpBase)
SendLocationHttp.prototype.load = function (longitude, latitude) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("SendLocationHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("SendLocationHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.sendLocation, table([1, "longitude", longitude], [1, "latitude", latitude]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// GetMatchsHttp ----------------------------------------------------
// 
// <request>
// </request>
// <response>
// 	<list code="users" ref="User" desc="用户列表"/>
// 	<list code="profiles" ref="Profile" desc="用户头像列表"/>
// </response>
GetMatchsHttp = xClass("GetMatchsHttp", HttpBase)
GetMatchsHttp.prototype.load = function () {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetMatchsHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetMatchsHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getMatchs, null, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// ConfirmMatchHttp ----------------------------------------------------
// 
// <request>
// 	<property code="friendUid" type="long" desc="待添加的好友id"/>
// </request>
// <response>
// </response>
ConfirmMatchHttp = xClass("ConfirmMatchHttp", HttpBase)
ConfirmMatchHttp.prototype.load = function (uid) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ConfirmMatchHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ConfirmMatchHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.confirmMatch, table([1, "friendUid", uid]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// 
// AckMatchHttp ----------------------------------------------------
// 
// <request>
// </request>
// <response>
// 	<property code="ret" type="int" desc="0：成功 1：失败 2：继续等待"/>
// </response>
AckMatchHttp = xClass("AckMatchHttp", HttpBase)
AckMatchHttp.prototype.load = function () {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("AckMatchHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("AckMatchHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.ackMatch, null, loadCallback, rpc.SendingPriority.kHigh, false)
}
// getPromoStatus
GetPromoStatusHttp = xClass("GetPromoStatusHttp", HttpBase)
GetPromoStatusHttp.prototype.load = function (appId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetPromoStatusHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetPromoStatusHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getPromStatus, table([1, "appId", appId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// getPromoReward
GetPromoRewardHttp = xClass("GetPromoRewardHttp", HttpBase)
GetPromoRewardHttp.prototype.load = function (appId, rewardId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetPromoRewardHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetPromoRewardHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getPromReward, table([1, "appId", appId], [1, "rewardId", rewardId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// clickPromo
ClickPromoHttp = xClass("ClickPromoHttp", HttpBase)
ClickPromoHttp.prototype.load = function (appId, idfa, mac) {
    var self = this
    cc.log("load")
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ClickPromoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ClickPromoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.clickProm, table(
        [1, "appId", appId],
        [1, "idfa", idfa],
        [1, "mac", mac]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetFruitsInfoHttp ---------------------------------------------------------
GetFruitsInfoHttp = xClass("GetFruitsInfoHttp", HttpBase)
GetFruitsInfoHttp.prototype.load = function () {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetFruitsInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetFruitsInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getFruitsInfo, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
// UpgradeFruitTreeHttp ---------------------------------------------------------
UpgradeFruitTreeHttp = xClass("UpgradeFruitTreeHttp", HttpBase)
UpgradeFruitTreeHttp.prototype.load = function () {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("UpgradeFruitTreeHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("UpgradeFruitTreeHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.upgradeFruitTree, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetPassNumHttp ---------------------------------------------------------
GetPassNumHttp = xClass("GetPassNumHttp", HttpBase)
GetPassNumHttp.prototype.load = function (levelId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetPassNumHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetPassNumHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getPassNum, table([1, "levelId", levelId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// GetShareRankHttp ---------------------------------------------------------
GetShareRankHttp = xClass("GetShareRankHttp", HttpBase)
GetShareRankHttp.prototype.load = function (levelId, score) {
    var self = this
    // if not kUserLogin then return self:onLoadingError(ZooErrorCode.kNotLoginError) end
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetShareRankHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetShareRankHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getShareRank, table([1, "levelId", levelId], [1, "score", score]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// getShareRankWithPosition ---------------------------------------------------------
getShareRankWithPosition = xClass("getShareRankWithPosition", HttpBase)
getShareRankWithPosition.prototype.load = function (levelId, score) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("getShareRankWithPosition error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("getShareRankWithPosition success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getShareRankWithPosition, table([1, "levelId", levelId], [1, "score", score]), loadCallback, rpc.SendingPriority.kHigh, false)
}
// CanSendLinkShowOff ---------------------------------------------------------
CanSendLinkShowOff = xClass("CanSendLinkShowOff", HttpBase)
CanSendLinkShowOff.prototype.load = function (levelId, score) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("CanSendLinkShowOff error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("CanSendLinkShowOff success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.canSendLinkShowOff, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
GetWeekMatchDataHttp = xClass("GetWeekMatchDataHttp", HttpBase)
GetWeekMatchDataHttp.prototype.load = function (levelId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetWeekMatchDataHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetWeekMatchDataHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getWeekMatchData, table([1, "levelId", levelId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
CommonRankType = table.const(table(
    [1, "kWeeklyRace", 1],
    [1, "kLaborDay", 6],
    [1, "kDragonBoat", 7],
    [1, "kSummerWeeklyMatch", 8]
))
GetCommonRankListHttp = xClass("GetCommonRankListHttp", HttpBase)
GetCommonRankListHttp.prototype.load = function (rankType, subType, levelId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetCommonRankListHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetCommonRankListHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getCommonRankList, table(
        [1, "rankType", rankType],
        [1, "subType", subType],
        [1, "levelId", levelId]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
ExchangeWeekMatchItemsHttp = xClass("ExchangeWeekMatchItemsHttp", HttpBase)
ExchangeWeekMatchItemsHttp.prototype.load = function (rewardId, number, levelId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ExchangeWeekMatchItemsHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ExchangeWeekMatchItemsHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.exchangeWeekMatchItems, table(
        [1, "rewardId", rewardId],
        [1, "num", number],
        [1, "levelId", levelId]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
ReceiveWeekMatchRewardsHttp = xClass("ReceiveWeekMatchRewardsHttp", HttpBase)
ReceiveWeekMatchRewardsHttp.prototype.load = function (id, levelId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ReceiveWeekMatchRewardsHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ReceiveWeekMatchRewardsHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.receiveWeekMatchRewards, table([1, "type", id], [1, "levelId", levelId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
CnValentineInfoHttp = xClass("CnValentineInfoHttp", HttpBase)
CnValentineInfoHttp.prototype.load = function () {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("CnValentineInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("CnValentineInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.cnValentineInfo, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
CnValentineExchangeHttp = xClass("CnValentineExchangeHttp", HttpBase)
CnValentineExchangeHttp.prototype.load = function (rewardId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("CnValentineExchangeHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("CnValentineExchangeHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.cnValentineExchange, table([1, "id", rewardId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
MergeConnectHttp = xClass("MergeConnectHttp", HttpBase)
MergeConnectHttp.prototype.load = function (weiboOpenId, qqOpenId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("MergeConnectHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("MergeConnectHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.mergeConnect, table([1, "weiboOpenId", weiboOpenId], [1, "qqOpenId", qqOpenId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
ClickActivityHttp = xClass("ClickActivityHttp", HttpBase)
ClickActivityHttp.prototype.load = function (actId) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ClickActivityHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ClickActivityHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.clickActivity, table([1, "actId", actId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
GetCashLogsHttp = xClass("GetCashLogsHttp", HttpBase)
GetCashLogsHttp.prototype.load = function (start, _end) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetCashLogsHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetCashLogsHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var d = table()
    d.start = start
    d.end = _end
    self.request(kHttpEndPoints.getCashLogs, d, loadCallback, rpc.SendingPriority.kHigh, false)
}
GetRabbitMatchDatasHttp = xClass("GetRabbitMatchDatasHttp", HttpBase)
GetRabbitMatchDatasHttp.prototype.load = function (levelId) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetRabbitMatchDatasHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetRabbitMatchDatasHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getRabbitMatchDatas, table([1, "levelId", levelId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
ReceiveRabbitMatchRewardsHttp = xClass("ReceiveRabbitMatchRewardsHttp", HttpBase)
ReceiveRabbitMatchRewardsHttp.prototype.load = function (levelId, rewardType, boxIdx) {
    var self = this
    // if not kUserLogin then return self:onLoadingError(ZooErrorCode.kNotLoginError) end
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(table())
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ReceiveRabbitMatchRewardsHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ReceiveRabbitMatchRewardsHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.receiveRabbitMatchRewards, table(
        [1, "type", rewardType],
        [1, "levelId", levelId],
        [1, "idx", boxIdx]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
OpNotifyType = table(
    [1, "kShare", 1],
    [1, "kNewYearAsk", 2],
    [1, "kXuanYao", 3],
    [1, "kSpringVideo", 4],
    [1, "kVideoAdPlay", 6],
    [1, "kAnniversaryShare", 7],
    [1, "kWeeklyMatchShare", 10],
    [1, "kSummerShare", 11],
    [1, "kOppoSummerLottery", 12],
    [1, "kQiXiLevel2015", 13]
)
OpNotifyHttp = xClass("OpNotifyHttp", HttpBase)
OpNotifyHttp.prototype.load = function (opType, param) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("OpNotifyHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("OpNotifyHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.opNotify, table([1, "type", opType], [1, "param", param]), loadCallback, rpc.SendingPriority.kHigh, false)
}
//支付宝签约
GetAliPaymentSign = xClass("GetAliPaymentSign", HttpBase)
GetAliPaymentSign.prototype.load = function (phoneNumber, aliAccount) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetAliPaymentSign error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@GetAliPaymentSign success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getAliPaymentSign, table([1, "phoneNum", phoneNumber], [1, "aliAccount", aliAccount]), loadCallback, rpc.SendingPriority.kHigh, false)
}
//获取关卡排名
GetLevelRanks = xClass("GetLevelRanks", HttpBase)
GetLevelRanks.prototype.load = function (startLevelId, endLevelId) {
    let self = this
    assert(type(startLevelId) === "number")
    assert(type(endLevelId) === "number")
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetLevelRanks error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetLevelRanks success !")
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getLevelRanks, table([1, "startLevelId", startLevelId], [1, "endLevelId", endLevelId]), loadCallback, rpc.SendingPriority.kHigh, false)
}
GoodsConfigHttp = xClass("GoodsConfigHttp", HttpBase)
GoodsConfigHttp.prototype.load = function () {
    var self = this
    // if not kUserLogin then return self:onLoadingError(ZooErrorCode.kNotLoginError) end
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GoodsConfigHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GoodsConfigHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.goodsConfig, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
RankExtraInfoHttp = xClass("RankExtraInfoHttp", HttpBase)
RankExtraInfoHttp.prototype.load = function (levelId, maxLevel, oldScore) {
    var self = this
    // if not kUserLogin then return self:onLoadingError(ZooErrorCode.kNotLoginError) end
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("RankExtraInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("RankExtraInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.rankExtraInfo, table(
        [1, "levelId", levelId],
        [1, "maxLevel", maxLevel],
        [1, "score", oldScore]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
GetUnlockInfoHttp = xClass("GetUnlockInfoHttp", HttpBase)
GetUnlockInfoHttp.prototype.load = function (clientTopLevel) {
    var self = this
    // if (!kUserLogin) {
    //     // WARN: maybe multi result
    //     return self.onLoadingError(ZooErrorCode.kNotLoginError)
    // }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getUnlockInfo, table([1, "clientTopLevel", clientTopLevel]), loadCallback, rpc.SendingPriority.kHigh, false)
}
RequestAreaHelpHttp = xClass("RequestAreaHelpHttp", HttpBase)
RequestAreaHelpHttp.prototype.load = function (areaId, friendUids) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.requestAreaHelp, table([1, "areaId", areaId], [1, "friendUids", friendUids]), loadCallback, rpc.SendingPriority.kHigh, false)
}
GetDebugRewardHttp = xClass("GetDebugRewardHttp", HttpBase)
GetDebugRewardHttp.prototype.load = function () {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.transponder.call(kHttpEndPoints.getDebugReward, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
//-----------------------------摇摇乐----------------------------------
GetShakeInfo = xClass("GetShakeInfo", HttpBase)
GetShakeInfo.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.shakeInfo, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
ShakeReward = xClass("ShakeReward", HttpBase)
ShakeReward.prototype.load = function (data) {
    var self = this
    // body
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.shakeReward, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
Shake = xClass("Shake", HttpBase)
Shake.prototype.load = function () {
    var self = this
    // body
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.shake, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
ReShake = xClass("ReShake", HttpBase)
ReShake.prototype.load = function () {
    var self = this
    // body
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.reShake, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
// ShakeExchange = xClass("ShakeExchange", HttpBase)
// ShakeExchange.prototype.load = function () {
//     var self = this
//     // body
//     var context = self
//     var loadCallback = function (endpoint, data, err) {
//         if (err) {
//             context.onLoadingError(err)
//         } else {
//             context.onLoadingComplete(data)
//         }
//     }
//     self.request(kHttpEndPoints.shakeExchange, table(), loadCallback, rpc.SendingPriority.kHigh, false)
// }
ShareShakeResetTimeHttp = xClass("ShareShakeResetTime", HttpBase)
ShareShakeResetTimeHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.shareWheel, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
BuyWheelResetHttp = xClass("BuyWheelReset", HttpBase)
BuyWheelResetHttp.prototype.load = function (cash) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.buyWheelReset, { cashNum: cash }, loadCallback, rpc.SendingPriority.kHigh, false)
}
GetWheelWinnersHttp = xClass("GetWheelWinners", HttpBase)
GetWheelWinnersHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getWheelWinners, {}, loadCallback, rpc.SendingPriority.kHigh, false)
}
//---------------------------摇摇乐end---------------------------------
GetMarkInfoHttp = xClass("GetMarkInfoHttp", HttpBase)
GetMarkInfoHttp.prototype.load = function (ischest) {
    var self = this
    // body
    var context = self
    var loadCallback = function (endpoint, data, err) {
        cc.log("GETMARKINFOHTTP_LOADCALLBACK", endpoint, data, err)
        if (err) {
            context.onLoadingError(err)
        } else {
            cc.log("COMPLETE")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getMarkInfo, { chest: ischest }, loadCallback, rpc.SendingPriority.kHigh, false)
}
GetMidasTokenHttp = xClass("GetMidasTokenHttp", HttpBase)
GetMidasTokenHttp.prototype.load = function (platform, sign, tradeId, goodsId, goodsType, amount, goodsName, totalFee, openId, accessToken, payToken, pf, pfKey, isLogin, authPf) {
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var context = self
    var loadCallback = function (endpoint, data, err) {
        cc.log("getMidasToken", endpoint, data, err)
        if (err) {
            context.onLoadingError(err)
        } else {
            cc.log("COMPLETE")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getMidasToken, table(
        [1, "platform", platform],
        [1, "checkStr", sign],
        [1, "tradeId", tradeId],
        [1, "goodsId", goodsId],
        [1, "goodsType", goodsType],
        [1, "num", amount],
        [1, "goodsName", goodsName],
        [1, "totalFee", Math.round(totalFee)],
        [1, "openId", openId],
        [1, "accessToken", accessToken],
        [1, "payToken", payToken],
        [1, "pf", pf],
        [1, "pfKey", pfKey],
        [1, "login", isLogin],
        [1, "authPf", authPf]
    ), loadCallback, rpc.SendingPriority.kHigh, false)
}
GetShareHttp = xClass("GetShareHttp", HttpBase)
GetShareHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetShareHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetShareHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var forkSrc = PlatformConfig.getForkSrc()
    self.request(kHttpEndPoints.getShare, table([1, "forkSrc", forkSrc]), loadCallback, rpc.SendingPriority.kHigh, false)
}
GetGlobalStarRankListHttp = xClass("GetGlobalStarRankListHttp", HttpBase)
GetGlobalStarRankListHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetGlobalStarRankListHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetGlobalStarRankListHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getGlobalStarRankList, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
GetOperatorActInfoHttp = xClass("GetOperatorActInfoHttp", HttpBase)
GetOperatorActInfoHttp.prototype.load = function (data) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetOperatorActInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetOperatorActInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getOperatorActInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
//回放请求
ReadReplayInfoHttp = xClass("ReadReplayInfoHttp", HttpBase)
ReadReplayInfoHttp.prototype.load = function (data) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ReadReplayInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ReadReplayInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(ApiList.readReplay, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

//模拟用户信息
MockUserHttp = xClass("MockUserHttp", HttpBase)
MockUserHttp.prototype.load = function (data) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("MockUserHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("MockUserHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(ApiList.mockUser, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

//模拟用户信息
MockUserByUUIDHttp = xClass("MockUserByUUIDHttp", HttpBase)
MockUserByUUIDHttp.prototype.load = function (data) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("MockUserByUUIDHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("MockUserByUUIDHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(ApiList.mockUserByUUID, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
GetSentencesHttp = xClass("GetSentencesHttp", HttpBase)
GetSentencesHttp.prototype.load = function (key) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetSentencesHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetSentencesHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getSentences, { key: key }, loadCallback, rpc.SendingPriority.kHigh, false)
}
// ResumeGameReplayHttp ---------------------------------------------------------
ResumeGameReplayHttp = xClass("ResumeGameReplayHttp", HttpBase)
ResumeGameReplayHttp.prototype.load = function (levelId, seed) {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("resume game replay fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("resume game replay success")
            context.onLoadingComplete(data)
        }
    }
    let data = table(
        [1, "levelId", levelId],
        [1, "seed", seed]
    );
    self.request(kHttpEndPoints.validateReplay, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

//
LevelRestoreCancelHttp = xClass("LevelRestoreCancelHttp", HttpBase) 
LevelRestoreCancelHttp.prototype.load = function(levelId, requestTime) {
    let self = this
    let param = {
        levelId, requestTime
    }
    self.request(kHttpEndPoints.levelRestoreCancel, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// ShortcutRewardEnterHttp ---------------------------------------------------------
ShortcutRewardEnterHttp = xClass("ShortcutRewardEnterHttp", HttpBase)
ShortcutRewardEnterHttp.prototype.load = function () {
    var self = this
    var context = self
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("shortcut reward enter fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("shortcut reward enter success")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getShortcutEnterRewards, null, loadCallback, rpc.SendingPriority.kHigh, false)
}

GetRefreshStarInfoHttp = xClass("GetRefreshStarInfoHttp", HttpBase)
GetRefreshStarInfoHttp.prototype.load = function () {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetRefreshStarInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetRefreshStarInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getRefreshStarInfo, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
CreateRefreshStarTeamHttp = xClass("CreateRefreshStarTeamHttp", HttpBase)
CreateRefreshStarTeamHttp.prototype.load = function () {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("CreateRefreshStarTeamHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("CreateRefreshStarTeamHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.createRefreshStarTeam, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
JoinRefreshStarTeamHttp = xClass("JoinRefreshStarTeamHttp", HttpBase)
JoinRefreshStarTeamHttp.prototype.load = function (inviteCode) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("JoinRefreshStarTeamHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("JoinRefreshStarTeamHttp success !")
            context.onLoadingComplete(data)
        }
    }
    let udid = he.MetaInfo.getInstance().getUdid()
    self.request(kHttpEndPoints.joinRefreshStarTeam, table([1, "inviteCode", inviteCode], [1, "deviceUdid", udid]), loadCallback, rpc.SendingPriority.kHigh, false)
}
GetRefreshStarRewardHttp = xClass("GetRefreshStarRewardHttp", HttpBase)
GetRefreshStarRewardHttp.prototype.load = function (id) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetRefreshStarRewardHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetRefreshStarRewardHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getRefreshStarReward, table([1, "rewardId", id]), loadCallback, rpc.SendingPriority.kHigh, false)
}
KickoutRefreshStarTeamHttp = xClass("KickoutRefreshStarTeamHttp", HttpBase)
KickoutRefreshStarTeamHttp.prototype.load = function (uid) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("KickoutRefreshStarTeamHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("KickoutRefreshStarTeamHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.kickoutRefreshStarTeam, table([1, "memberUid", uid]), loadCallback, rpc.SendingPriority.kHigh, false)
}
RenameRefreshStarTeamHttp = xClass("RenameRefreshStarTeamHttp", HttpBase)
RenameRefreshStarTeamHttp.prototype.load = function (name) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("RenameRefreshStarTeamHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("RenameRefreshStarTeamHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.renameRefreshStarTeam, table([1, "newName", name]), loadCallback, rpc.SendingPriority.kHigh, false)
}

UserDetailHttp = xClass("UserDetailHttp", HttpBase)
UserDetailHttp.prototype.load = function (frd) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("UserDetailHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("UserDetailHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.userDetail, table([1, "frd", frd]), loadCallback, rpc.SendingPriority.kHigh, false)
}
WeekGameGetRankHttp = xClass("WeekGameGetRankHttp", HttpBase)
WeekGameGetRankHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("WeekGameGetRankHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("WeekGameGetRankHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.wmRank, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
WeekGameGetRankHistoryHttp = xClass("WeekGameGetRankHistoryHttp", HttpBase)
WeekGameGetRankHistoryHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("WeekGameGetRankHistoryHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("WeekGameGetRankHistoryHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.wmRankHistory, data || table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
WeekGameGetNearHttp = xClass("WeekGameGetNearHttp", HttpBase)
WeekGameGetNearHttp.prototype.load = function (areaCode) {
    let self = this
    // body
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.wmNear, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
WeekGameUpdateServerSelfRankHttp = xClass("WeekGameUpdateServerSelfRankHttp", HttpBase)
WeekGameUpdateServerSelfRankHttp.prototype.load = function () {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("WeekGameUpdateServerSelfRankHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("WeekGameUpdateServerSelfRankHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.wmGetMyRank, table(), loadCallback, rpc.SendingPriority.kHigh, false)
}
WeekGameGetUserDetailHttp = xClass("WeekGameGetUserDetailHttp", HttpBase)
WeekGameGetUserDetailHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("WeekGameGetUserDetailHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("WeekGameGetUserDetailHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.userDetail, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

GetGiftBagStatesHttp = xClass("GetGiftBagStatesHttp", HttpBase)
GetGiftBagStatesHttp.prototype.load = function (name) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetGiftBagStatesHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetGiftBagStatesHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getGiftBagStates, null, loadCallback, rpc.SendingPriority.kHigh, false)
}
ValideGiftBagHttp = xClass("ValideGiftBagHttp", HttpBase)
ValideGiftBagHttp.prototype.load = function (giftId) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ValideGiftBagHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ValideGiftBagHttp success !")
            context.onLoadingComplete(data)
        }
    }
    let data = {
        giftId: giftId
    }
    self.request(kHttpEndPoints.valideGiftBag, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
ShareInviteCheckkHttp = xClass("ShareInviteCheckkHttp", HttpBase)
ShareInviteCheckkHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("ShareInviteCheckkHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("ShareInviteCheckkHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.shareInviteCheck, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
GetShareInviteRewardskHttp = xClass("GetShareInviteRewardskHttp", HttpBase)
GetShareInviteRewardskHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetShareInviteRewardskHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetShareInviteRewardskHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getShareInviteRewards, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
CoverInfoHttp = xClass("CoverInfoHttp", HttpBase)
CoverInfoHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("CoverInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("CoverInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.coverInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// 特惠商城
DiscountShopInfoHttp = xClass("DiscountShopInfoHttp", HttpBase)
DiscountShopInfoHttp.prototype.load = function () {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("DiscountShopInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("DiscountShopInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.dmInfo, null, loadCallback, rpc.SendingPriority.kHigh, false)
}

// 特惠商城免费礼包领取
GetDiscountShopFreeHttp = xClass("GetDiscountShopFreeHttp", HttpBase)
GetDiscountShopFreeHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetDiscountShopFreeHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetDiscountShopFreeHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.dmBuy, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// 查询订单支付是否已完成
QueryPayLogHttp = xClass("QueryPayLogHttp", HttpBase)
QueryPayLogHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("QueryPayLogHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("QueryPayLogHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.queryPayLog, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 查询wanba玩家vip等级和礼包信息
GetWanbaVipLevelHttp = xClass("GetWanbaVipLevelHttp", HttpBase)
GetWanbaVipLevelHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetWanbaVipLevelHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("GetWanbaVipLevelHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getWanbaVipLevel, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// 抖音小游戏支付初始化
TTlightgamePaymentGetInfoHttp = xClass("TTlightgamePaymentGetInfoHttp", HttpBase)
TTlightgamePaymentGetInfoHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("TTGamePaymentGetInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("TTGamePaymentGetInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.ttlightgamePaymentGetInfoHttp, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// vivo轻游戏支付初始化
VivoQuickgamePaymentGetInfoHttp = xClass("VivoQuickgamePaymentGetInfoHttp", HttpBase)
VivoQuickgamePaymentGetInfoHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("VivoQuickgamePaymentGetInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("VivoQuickgamePaymentGetInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.vivoQuickgamePaymentGetInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// huawei快游戏支付初始化
HuaweiQuickgamePaymentGetInfoHttp = xClass("HuaweiQuickgamePaymentGetInfoHttp", HttpBase)
HuaweiQuickgamePaymentGetInfoHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("HuaweiQuickgamePaymentGetInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("HuaweiQuickgamePaymentGetInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.huaweiQuickGamePaymentGetInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

HuaweiQuickgamePaymentGetInfoV2Http = xClass("HuaweiQuickgamePaymentGetInfoV2Http", HttpBase)
HuaweiQuickgamePaymentGetInfoV2Http.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("HuaweiQuickgamePaymentGetInfoV2Http error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("HuaweiQuickgamePaymentGetInfoV2Http success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.huaweiQuickGamePaymentGetInfoV2, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
HuaweiCheckOrderHttp = xClass("HuaweiCheckOrderHttp", HttpBase)
HuaweiCheckOrderHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("HuaweiCheckOrderHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("HuaweiCheckOrderHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.huaweiCheckOrder, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// 百度轻游戏支付初始化
BaidulightgamePaymentGetInfoHttp = xClass("BaidulightgamePaymentGetInfoHttp", HttpBase)
BaidulightgamePaymentGetInfoHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("BaidulightgamePaymentGetInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("BaidulightgamePaymentGetInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.baiduQuickgamePaymentGetInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// honor轻游戏支付初始化
HonorQuickgamePaymentGetInfoHttp = xClass("HonorQuickgamePaymentGetInfoHttp", HttpBase)
HonorQuickgamePaymentGetInfoHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("HonorQuickgamePaymentGetInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("HonorQuickgamePaymentGetInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.honorQuickgamePaymentGetInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// oppo轻游戏支付初始化
OppoQuickgamePaymentGetInfoHttp = xClass("OppoQuickgamePaymentGetInfoHttp", HttpBase)
OppoQuickgamePaymentGetInfoHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("OppoQuickgamePaymentGetInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("OppoQuickgamePaymentGetInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.oppoQuickgamePaymentGetInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// mi轻游戏支付初始化
MiQuickgamePaymentGetInfoHttp = xClass("MiQuickgamePaymentGetInfoHttp", HttpBase)
MiQuickgamePaymentGetInfoHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("MiQuickgamePaymentGetInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("MiQuickgamePaymentGetInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.xiaomiQuickGamePaymentGetInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// ks轻游戏支付初始化
KsQuickgamePaymentGetInfoHttp = xClass("KsQuickgamePaymentGetInfoHttp", HttpBase)
KsQuickgamePaymentGetInfoHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("KsQuickgamePaymentGetInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("KsQuickgamePaymentGetInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.kuaishouGamePaymentGetInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// qq轻游戏支付初始化
QQlightgamePaymentGetInfoHttp = xClass("QQlightgamePaymentGetInfoHttp", HttpBase)
QQlightgamePaymentGetInfoHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("QQlightgamePaymentGetInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("QQlightgamePaymentGetInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.qqlightgamePaymentGetInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// qq轻游戏支付
/*QQlightgamePaymentPayHttp = xClass("QQlightgamePaymentPayHttp", HttpBase)
QQlightgamePaymentPayHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("QQlightgamePaymentPayHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("QQlightgamePaymentPayHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.qqlightgamePaymentPay, data, loadCallback, rpc.SendingPriority.kHigh, false)
}*/

// 微信支付初始化
WechatgamePaymentGetInfoHttp = xClass("WechatgamePaymentGetInfoHttp", HttpBase)
WechatgamePaymentGetInfoHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("WechatgamePaymentGetInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("WechatgamePaymentGetInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.wechatgamePaymentGetInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// 微信支付
WechatgamePaymentPayHttp = xClass("WechatgamePaymentPayHttp", HttpBase)
WechatgamePaymentPayHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("WechatgamePaymentPayHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("WechatgamePaymentPayHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.wechatgamePaymentPay, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// 微信ios支付获取预订单
WechatgamePreOrderHttp = xClass("WechatgamePreOrderHttp", HttpBase)
WechatgamePreOrderHttp.prototype.load = function (data) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("WechatgamePreOrderHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("WechatgamePreOrderHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.createOrder, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// 微信ios支付查取订单状态
WechatgmaeCheckOrderHttp = xClass("WechatgmaeCheckOrderHttp", HttpBase)
WechatgmaeCheckOrderHttp.prototype.load = function (orderid) {
    let self = this
    let context = self
    let order = table()
    table.insert(order, orderid)

    let orders = $tableToArray(order)
    delete orders.__isLuaTable

    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("WechatgmaeCheckOrderHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("WechatgmaeCheckOrderHttp success !")
            context.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.checkPayOrder, table([1, "order", orders]), loadCallback, rpc.SendingPriority.kHigh, false)

}
// 微信小游戏加五步info
Add5StepWxGroupShareInfo = xClass("Add5StepWxGroupShareInfo", HttpBase)
Add5StepWxGroupShareInfo.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("Add5StepWxGroupShareInfo error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("Add5StepWxGroupShareInfo success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.add5StepWxGroupShareInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

// 微信小游戏加步数info（目前仅金币大作战时候，后续欲全部统一到该接口）
AddStepWxGroupShareInfo = xClass("AddStepWxGroupShareInfo", HttpBase)
AddStepWxGroupShareInfo.prototype.load = function (shareType, shareData = {}) {
    var self = this
    let data = {
        shareType: shareType,
        data: shareData
    }
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("AddStepWxGroupShareInfo error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("AddStepWxGroupShareInfo success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.addStepWxGroupShareInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 微信小游戏精力info
AddEnergyWxGroupShareInfo = xClass("AddEnergyWxGroupShareInfo", HttpBase)
AddEnergyWxGroupShareInfo.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("AddEnergyWxGroupShareInfo error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("AddEnergyWxGroupShareInfo success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.addEnergyWxGroupShareInfo, data, loadCallback, rpc.SendingPriority.kHigh, false)
}
CanShareInHighScoreHttp = xClass("CanShareInHighScoreHttp", HttpBase)
CanShareInHighScoreHttp.prototype.load = function () {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("CanShareInHighScoreHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("CanShareInHighScoreHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.canShareInHighScore, {}, loadCallback, rpc.SendingPriority.kHigh, false)
}
GetIslandInfo = xClass("GetIslandInfo", HttpBase)
GetIslandInfo.prototype.load = function (uid) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetIslandInfo error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("GetIslandInfo success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getIslandInfo, { uid: uid, newUnlock: true }, loadCallback, rpc.SendingPriority.kHigh, false)
}
GetIslandReward = xClass("GetIslandReward", HttpBase)
GetIslandReward.prototype.load = function (id) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetIslandReward error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("GetIslandReward success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getIslandReward, { id: id }, loadCallback, rpc.SendingPriority.kHigh, false)
}
CanIslandGetReward = xClass("CanIslandGetReward", HttpBase)
CanIslandGetReward.prototype.load = function () {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("CanIslandGetReward error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("CanIslandGetReward success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.canIslandGetReward, {}, loadCallback, rpc.SendingPriority.kHigh, false)
}
GetAdRewardsHttp = xClass("GetAdRewardsHttp", HttpBase)
GetAdRewardsHttp.prototype.load = function (data) {
    var self = this
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("GetAdRewardsHttp error: " + err)
            self.onLoadingError(err)
        } else {
            he_log_info("GetAdRewardsHttp success !")
            self.onLoadingComplete(data)
        }
    }
    self.request(kHttpEndPoints.getAdRewards, data, loadCallback, rpc.SendingPriority.kHigh, false)
}

buildCallback = function (context) {
    let self = context
    return function (endpoint, data, err) {
        if (err) {
            self.onLoadingError(err)
        } else {
            self.onLoadingComplete(data)
        }
    }
}

QueryUserInOpenConsoleListHttp = xClass("QueryUserInOpenConsoleListHttp", HttpBase)
QueryUserInOpenConsoleListHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.queryUserInOpenConsoleList, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

OneStepWatchVideoHttp = xClass("OneStepWatchVideoHttp", HttpBase)
OneStepWatchVideoHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.oneStepWatchVideo, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
OneStepActivityInfoHttp = xClass("OneStepActivityInfoHttp", HttpBase)
OneStepActivityInfoHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.oneStepActivityInfo, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
OneStepGetShareIdHttp = xClass("OneStepGetShareIdHttp", HttpBase)
OneStepGetShareIdHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.oneStepGetShareId, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
TimeModeActivityInfoHttp = xClass("TimeModeActivityInfoHttp", HttpBase)
TimeModeActivityInfoHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.timeModeActivityInfo, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
TimeModeGetShareIdHttp = xClass("TimeModeGetShareIdHttp", HttpBase)
TimeModeGetShareIdHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.timeModeGetShareId, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
TimeModeWatchVideoHttp = xClass("TimeModeWatchVideoHttp", HttpBase)
TimeModeWatchVideoHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.timeModeWatchVideo, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}

TimeModeAddSecHttp = xClass("TimeModeAddSecHttp", HttpBase)
TimeModeAddSecHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.timeMatchWatchAd, { type: 1 }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}

TimeModeShareHttp = xClass("TimeModeShareHttp", HttpBase)
TimeModeShareHttp.prototype.load = function (uid) {
    var self = this
    self.request(kHttpEndPoints.timeModeShareInfo, { uid: uid }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}

CoinMatchActivityInfoHttp = xClass("CoinMatchActivityInfoHttp", HttpBase)
CoinMatchActivityInfoHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.coinMatchActivityInfo, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
CoinMatchInvitedInfoHttp = xClass("CoinMatchInvitedInfoHttp", HttpBase)
CoinMatchInvitedInfoHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.coinMatchInvitedInfo, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
GoldMatchActivityInfoHttp = xClass("GoldMatchActivityInfoHttp", HttpBase)
GoldMatchActivityInfoHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.goldMatchActivityInfo, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
GoldMatchGetShareIdHttp = xClass("GoldMatchGetShareIdHttp", HttpBase)
GoldMatchGetShareIdHttp.prototype.load = function (uid) {
    var self = this
    self.request(kHttpEndPoints.goldMatchGetShareId, {
        uid: uid
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
GoldMatchShareInfoHttp = xClass("GoldMatchShareInfoHttp", HttpBase)
GoldMatchShareInfoHttp.prototype.load = function (uid, shareId) {
    var self = this
    self.request(kHttpEndPoints.goldMatchShareInfo, {
        uid: uid,
        shareId: shareId
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
GoldMatchClosePanelHttp = xClass("GoldMatchClosePanelHttp", HttpBase)
GoldMatchClosePanelHttp.prototype.load = function (uid, shareId) {
    var self = this
    self.request(kHttpEndPoints.goldMatchClosePanel, {
        uid: uid
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
//限时礼包接口
TimeLimitGiftInfoHttp = xClass("TimeLimitGiftInfoHttp", HttpBase)
TimeLimitGiftInfoHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.timeLimitGiftInfo, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}

AcceptTimeLimitShareRewardHttp = xClass("AcceptTimeLimitShareRewardHttp", HttpBase)
AcceptTimeLimitShareRewardHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.acceptTimeLimitShareReward, null, buildCallback(self), rpc.SendingPriority.kHigh, false)
}

TimeLimitGiftClickShareHttp = xClass("TimeLimitGiftClickShareHttp", HttpBase)
TimeLimitGiftClickShareHttp.prototype.load = function (inviteCode, shareTime) {
    var self = this
    self.request(kHttpEndPoints.timeLimitGiftClickShare, {
        inviteCode: inviteCode,
        shareTime: shareTime
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}

// Gacha 摇一摇 获取信息
GachaInfoHttp = xClass("GachaInfoHttp", HttpBase)
GachaInfoHttp.prototype.load = function (useMask) {
    this.request(kHttpEndPoints.getGachaInfo, null, buildCallback(this), rpc.SendingPriority.kHigh, false, useMask)
}

// Gacha 摇一摇 看广告得奖券
GachaWatchAdHttp = xClass("GachaWatchAdHttp", HttpBase)
GachaWatchAdHttp.prototype.load = function () {
    this.request(kHttpEndPoints.gachaTicketWatchAd, null, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// Gacha 摇一摇 获取分享ID
GachaGetShareIdHttp = xClass("GachaGetShareIdHttp", HttpBase)
GachaGetShareIdHttp.prototype.load = function (useMask) {
    this.request(kHttpEndPoints.gachaGetShareId, null, buildCallback(this), rpc.SendingPriority.kHigh, false, useMask)
}

// Gacha 摇一摇 点击分享链接
GachaClickShareHttp = xClass("GachaClickShareHttp", HttpBase)
/**
 * 点击分享链接
 * @param inviteCode: 邀请人Id
 * @param shareId: 分享Id
 * @param shareTime: 分享时间（时间戳，精确到毫秒）
 */
GachaClickShareHttp.prototype.load = function (inviteCode, shareId, shareTime) {
    this.request(kHttpEndPoints.gachaClickShare,
        { inviteCode: inviteCode, shareId: shareId, shareTime: shareTime },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// Gacha 摇一摇 抽奖
GachaRewardHttp = xClass("GachaRewardHttp", HttpBase)
GachaRewardHttp.prototype.load = function () {
    this.request(kHttpEndPoints.gachaReward, null, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// Gacha 摇一摇 领取额外奖励
GachaExtraRewardHttp = xClass("GachaExtraRewardHttp", HttpBase)
GachaExtraRewardHttp.prototype.load = function (useMask) {
    this.request(kHttpEndPoints.gachaExtraReward, null, buildCallback(this), rpc.SendingPriority.kHigh, false, useMask)
}

// Gacha 摇一摇 提现
GachaCashHttp = xClass("GachaCashHttp", HttpBase)
GachaCashHttp.prototype.load = function () {
    this.request(kHttpEndPoints.gachaDrawCash, null, buildCallback(this), rpc.SendingPriority.kHigh, false)
}
// 攻略获取用户攻略信息
GetUserStrategyInfoHttp = xClass("GetUserStrategyInfoHttp", HttpBase)
GetUserStrategyInfoHttp.prototype.load = function (uid, content, levelId) {
    var self = this
    self.request(kHttpEndPoints.getUserStrategyInfo, {
        uid: uid,
        levelId,
        version: ResManager.getLevelMd5(levelId) + (DAManager.getInstance().useV2() ? "new" : "")
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}
// 点击分享获取攻略享接口
ClickStrategyShareHttp = xClass("ClickStrategyShareHttp", HttpBase)
ClickStrategyShareHttp.prototype.load = function (uid, strategyId, levelId) {
    var self = this
    self.request(kHttpEndPoints.clickStrategyShare, {
        uid: uid,
        strategyId: strategyId,
        level: levelId,
        version: ResManager.getLevelMd5(levelId) + (DAManager.getInstance().useV2() ? "new" : "")
    }, buildCallback(self), rpc.SendingPriority.kHigh, false)
}

//用户一元礼包邀请信息
UserExtendHttp = xClass("UserExtendHttp", HttpBase)
UserExtendHttp.prototype.load = function () {
    this.request(kHttpEndPoints.userExtend, null, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 获取宝箱额外奖励
GetStarChestExtraRewardHttp = xClass("GetStarChestExtraRewardHttp", HttpBase)
GetStarChestExtraRewardHttp.prototype.load = function () {
    this.request(kHttpEndPoints.getStarChestExtraReward,
        null,
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 获取宝箱分享ID
StarChestExtraRewardGetShareIdHttp = xClass("StarChestExtraRewardGetShareIdHttp", HttpBase)
StarChestExtraRewardGetShareIdHttp.prototype.load = function () {
    this.request(kHttpEndPoints.starChestExtraRewardGetShareId,
        null,
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}
//  获取关前道具购买信息
GetPropConfigHttp = xClass("GetPropConfigHttp", HttpBase)
GetPropConfigHttp.prototype.load = function () {
    var self = this
    self.request(kHttpEndPoints.getPropsBeforeLevel, {}, buildCallback(self), rpc.SendingPriority.kHigh, false)
}

// 风车币打开面板
GetAdRewardsHttp = xClass("GetAdRewardsHttp", HttpBase)
GetAdRewardsHttp.prototype.load = function () {
    this.request(kHttpEndPoints.getAdRewards,
        null,
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 风车币不足查询分享
FetchHelpRewardsHttp = xClass("FetchHelpRewardsHttp", HttpBase)
FetchHelpRewardsHttp.prototype.load = function (shareType) {
    this.request(kHttpEndPoints.fetchHelpRewards,
        {
            shareType: shareType
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 风车币不足获取分享ID
HappycoinGetShareIdHttp = xClass("HappycoinGetShareIdHttp", HttpBase)
HappycoinGetShareIdHttp.prototype.load = function () {
    this.request(kHttpEndPoints.happycoinGetShareId,
        null,
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 风车币不足点击分享链接
HappycoinShareClickHttp = xClass("HappycoinShareClickHttp", HttpBase)
HappycoinShareClickHttp.prototype.load = function (inviteCode, shareId) {
    this.request(kHttpEndPoints.happycoinShareClick,
        {
            inviteCode: inviteCode,
            shareId: shareId
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 风车币不足获得分享ID列表
ShareInfoListHttp = xClass("ShareInfoListHttp", HttpBase)
ShareInfoListHttp.prototype.load = function (shareType) {
    this.request(kHttpEndPoints.shareInfoList,
        {
            shareType: shareType
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 银币不足获取获得银币途径
GetObtainCoinHttp = xClass("GetObtainCoinHttp", HttpBase)
GetObtainCoinHttp.prototype.load = function () {
    this.request(kHttpEndPoints.getObtainCoinWay, {}, buildCallback(this), rpc.SendingPriority.kHigh, false)
}
// 限时挑战分享ID
TimeMatchAddTimeGetShareIdHttp = xClass("TimeMatchAddTimeGetShareIdHttp", HttpBase)
TimeMatchAddTimeGetShareIdHttp.prototype.load = function () {
    this.request(kHttpEndPoints.timeMatchAddTimeGetShareId,
        null,
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 银币不足获取分享Id
AddCoinGetShareIdHttp = xClass("AddCoinGetShareIdHttp", HttpBase)
AddCoinGetShareIdHttp.prototype.load = function () {
    var data = {}
    this.request(kHttpEndPoints.addCoinGetShareId, data, buildCallback(this), rpc.SendingPriority.kHigh, false)
}
// 限时挑战点击分享
TimeMatchAddTimeShareClickHttp = xClass("TimeMatchAddTimeShareClickHttp", HttpBase)
TimeMatchAddTimeShareClickHttp.prototype.load = function (inviteCode, shareId) {
    this.request(kHttpEndPoints.timeMatchAddTimeShareClick,
        {
            inviteCode: inviteCode,
            shareId: shareId
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 限时挑战查询分享点击
TimeMatchAddTimeCheckHttp = xClass("TimeMatchAddTimeCheckHttp", HttpBase)
TimeMatchAddTimeCheckHttp.prototype.load = function () {
    this.request(kHttpEndPoints.timeMatchAddTimeCheck,
        null,
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 关末加步数优化
AddStepLevelEndInfoHttp = xClass("AddStepLevelEndInfoHttp", HttpBase)
AddStepLevelEndInfoHttp.prototype.load = function (factor, adInterval, shareInterval) {
    this.request(kHttpEndPoints.addStepLevelEndInfo,
        {
            factor: factor,
            adInterval: adInterval,
            shareInterval: shareInterval,
            // abGroupId: UserManager.getInstance().addStepAdGroup
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 关末加步数发出群分享求助
AddStepLevelEndSendShareHttp = xClass("AddStepLevelEndSendShareHttp", HttpBase)
AddStepLevelEndSendShareHttp.prototype.load = function (shareId) {
    this.request(kHttpEndPoints.addStepLevelEndSendShare,
        {
            shareId: shareId
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 关末加步数优化分享查询
AddStepLevelEndShareQueryHttp = xClass("AddStepLevelEndShareQueryHttp", HttpBase)
AddStepLevelEndShareQueryHttp.prototype.load = function (shareId) {
    this.request(kHttpEndPoints.addStepLevelEndShareQuery,
        {
            shareId: shareId
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 关末加步数付费购买步数
AddStepLevelEndBuyStepHttp = xClass("AddStepLevelEndBuyStepHttp", HttpBase)
AddStepLevelEndBuyStepHttp.prototype.load = function (addStep) {
    this.request(kHttpEndPoints.addStepLevelEndBuyStep,
        {
            addStep: addStep
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 关末加步数付费购买很多步数
AddStepUpgradeBuyHttp = xClass("AddStepUpgradeBuyHttp", HttpBase)
AddStepUpgradeBuyHttp.prototype.load = function () {
    this.request(kHttpEndPoints.addStepUpgradeBuy,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

/**
 * 获取关末礼包信息
 */
LevelEndGiftbagInfoHttp = xClass("LevelEndGiftbagInfoHttp", HttpBase)
LevelEndGiftbagInfoHttp.prototype.load = function () {
    this.request(kHttpEndPoints.levelEndGiftbagInfo, {
        serverId: isPlatformIOS() ? 2 : 1,
        v2: true,
    }, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

/**
 * 获取关末礼包分享ID
 */
LevelEndShareGiftGetShareIdHttp = xClass("LevelEndShareGiftGetShareIdHttp", HttpBase)
LevelEndShareGiftGetShareIdHttp.prototype.load = function () {
    this.request(kHttpEndPoints.levelEndShareGiftGetShareId, {}, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

/**
 * 查询关末礼包奖励次数
 */
LevelEndShareGiftQueryHttp = xClass("LevelEndShareGiftQueryHttp", HttpBase)
LevelEndShareGiftQueryHttp.prototype.load = function () {
    this.request(kHttpEndPoints.levelEndShareGiftQuery, {}, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 获取主线关卡求超越分享相关配置
GetPassLevelShowOffConfigHttp = xClass("GetPassLevelShowOffConfigHttp", HttpBase)
GetPassLevelShowOffConfigHttp.prototype.load = function (uid) {
    this.request(kHttpEndPoints.getPassLevelShowOffConfig,
        {
            uid: uid
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 主线关卡分享相关信息
GetPassLevelShowOffInfo = xClass("GetPassLevelShowOffInfo", HttpBase)
GetPassLevelShowOffInfo.prototype.load = function (uid, levelId, star) {
    this.request(kHttpEndPoints.getPassLevelShowOffInfo,
        {
            uid: uid,
            levelId: levelId,
            star: star
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

/**
 * 获取商店信息
 */
GetMarketInfoHttp = xClass("GetMarketInfoHttp", HttpBase)
GetMarketInfoHttp.prototype.load = function () {
    this.request(kHttpEndPoints.getMarketInfo, {}, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

//  新版签到

//  获取当前玩家签到版本以及新版签到信息
GetMarkVersionHttp = xClass("GetMarkVersionHttp", HttpBase)
GetMarkVersionHttp.prototype.load = function () {
    this.request(kHttpEndPoints.getMarkVersion, null, buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// 查邀请新用户数
GetInviteNewUserCntHttp = xClass("GetInviteNewUserCntHttp", HttpBase)
GetInviteNewUserCntHttp.prototype.load = function (data) {
    this.request(kHttpEndPoints.getInviteNewCount, data, buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// pvp打开面板
GetPvpInfoHttp = xClass("GetPvpInfoHttp", HttpBase)
GetPvpInfoHttp.prototype.load = function () {
    this.request(kHttpEndPoints.getPvpInfo,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp排行榜
PvpRankListHttp = xClass("PvpRankListHttp", HttpBase)
PvpRankListHttp.prototype.load = function () {
    this.request(kHttpEndPoints.pvpRankList,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp战报
PvpReportListHttp = xClass("PvpReportListHttp", HttpBase)
PvpReportListHttp.prototype.load = function () {
    this.request(kHttpEndPoints.pvpReportList,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp领取积分进度奖励
GainScoreRewardHttp = xClass("GainScoreRewardHttp", HttpBase)
GainScoreRewardHttp.prototype.load = function (score) {
    this.request(kHttpEndPoints.gainScoreReward,
        {
            score: score
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp看广告拿门票
GainPvpAdCountHttp = xClass("GainPvpAdCountHttp", HttpBase)
GainPvpAdCountHttp.prototype.load = function (score) {
    this.request(kHttpEndPoints.gainPvpAdCount,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp点邀请检查次数
FriendPvpInviteinfoHttp = xClass("FriendPvpInviteinfoHttp", HttpBase)
FriendPvpInviteinfoHttp.prototype.load = function (uid) {
    this.request(kHttpEndPoints.friendPvpInviteinfo,
        {
            targetUid: uid
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp检查过期奖励
FriendPvpCheckRewardExpireHttp = xClass("FriendPvpCheckRewardExpireHttp", HttpBase)
FriendPvpCheckRewardExpireHttp.prototype.load = function (uid) {
    this.request(kHttpEndPoints.friendPvpCheckRewardExpire,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp进行匹配
FriendPvpMatchHttp = xClass("FriendPvpMatchHttp", HttpBase)
FriendPvpMatchHttp.prototype.load = function (time) {
    this.request(kHttpEndPoints.friendPvpMatch,
        {
            matchTime: time
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp取消匹配
FriendPvpMatchCancelHttp = xClass("FriendPvpMatchCancelHttp", HttpBase)
FriendPvpMatchCancelHttp.prototype.load = function () {
    this.request(kHttpEndPoints.friendPvpMatchCancel,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp获得机器人信息
FriendPvpRobotHttp = xClass("FriendPvpRobotHttp", HttpBase)
FriendPvpRobotHttp.prototype.load = function () {
    this.request(kHttpEndPoints.friendPvpRobot,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

// pvp排行榜获取用户信息
RankUserInfoHttp = xClass("RankUserInfoHttp", HttpBase)
RankUserInfoHttp.prototype.load = function (uid) {
    this.request(kHttpEndPoints.rankUserInfo,
        {
            targetId: uid
        },
        buildCallback(this), rpc.SendingPriority.kHigh, false)
}

//  获取用户互动邀请奖励信息
GetInteractiveInfoHttp = xClass("GetInteractiveInfoHttp", HttpBase)
GetInteractiveInfoHttp.prototype.load = function (data) {
    this.request(kHttpEndPoints.getInteractiveInfo, data, buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 用户发送小卡片成功加奖励进度
InteractiveProgressPlusHttp = xClass("InteractiveProgressPlusHttp", HttpBase)
InteractiveProgressPlusHttp.prototype.load = function () {
    this.request(kHttpEndPoints.addProgressReward, {}, buildCallback(this), rpc.SendingPriority.kHigh, true)
}

//  领取用户互动邀请托管奖励
FetchInteractiveRewardHttp = xClass("FetchInteractiveRewardHttp", HttpBase)
FetchInteractiveRewardHttp.prototype.load = function (data) {
    this.request(kHttpEndPoints.fetchInteractiveReward, data, buildCallback(this), rpc.SendingPriority.kHigh, true)
}

//  领取用户互动邀请进度奖励
FetchInteractiveProgressGetHttp = xClass("FetchInteractiveProgressGetHttp", HttpBase)
FetchInteractiveProgressGetHttp.prototype.load = function () {
    this.request(kHttpEndPoints.fetchFriendsHelpEachOtherProgressReward, {}, buildCallback(this), rpc.SendingPriority.kHigh, true)
}

//格子广告判断状态
GetGridBannerConditionHttp = xClass("GetGridBannerConditionHttp", HttpBase)
GetGridBannerConditionHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getGridBannerCondition,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

//插屏广告当天次数
GetInterAdHttp = xClass("GetInterAdHttp", HttpBase)
GetInterAdHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getInterAd,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 星星宝箱数据
GetStarChestInfoHttp = xClass("GetStarChestInfoHttp", HttpBase)
GetStarChestInfoHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getStarChestInfo,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 星星抽奖获取奖励池信息
GetStarRewardPoolHttp = xClass("GetStarRewardPoolHttp", HttpBase)
GetStarRewardPoolHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getStarRewardPool,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 星星抽奖立即刷新奖池
DoStarRewardRefleshHttp = xClass("DoStarRewardRefleshHttp", HttpBase)
DoStarRewardRefleshHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.doStarRewardReflesh,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 星星抽奖获取分享id
GetStarRewardShareIdHttp = xClass("GetStarRewardShareIdHttp", HttpBase)
GetStarRewardShareIdHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getStarRewardShareId,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 星星抽奖获取现金奖轮播消息
GetStarRewardCashMsgHttp = xClass("GetStarRewardCashMsgHttp", HttpBase)
GetStarRewardCashMsgHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getStarRewardCashMsg,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 星星抽奖显示奖励
ShowStarRewardDrawHttp = xClass("ShowStarRewardDrawHttp", HttpBase)
ShowStarRewardDrawHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.showStarRewardDraw,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 精力红包真实分享获取分享ID
GetRedbagRealShareIdHttp = xClass("GetRedbagRealShareIdHttp", HttpBase)
GetRedbagRealShareIdHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getQQRedbagShareId, {}, buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 精力红包真实分享获取奖励
GetRedbagRealShareSuccessHttp = xClass("GetRedbagRealShareSuccessHttp", HttpBase)
GetRedbagRealShareSuccessHttp.prototype.load = function (gainType) {
    let self = this
    self.request(kHttpEndPoints.redbagShareSuccess, { gainType: gainType }, buildCallback(this), rpc.SendingPriority.kHigh, true)
}
// 抖音分享视频
TTlightgameVideoShareRewardHttp = xClass("TTlightgameVideoShareRewardHttp", HttpBase)
TTlightgameVideoShareRewardHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.ttlightgameGainVideoShareReward,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 获取岛屿解锁信息
GetIslandUnlockInfoHttp = xClass("GetIslandUnlockInfoHttp", HttpBase)
GetIslandUnlockInfoHttp.prototype.load = function (param) {
    let self = this
    self.request(kHttpEndPoints.getIslandUnlockInfo,
        param,
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 获取岛屿解锁好友帮助分享ID
GetIslandUnlockShareIdHttp = xClass("GetIslandUnlockShareIdHttp", HttpBase)
GetIslandUnlockShareIdHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getIslandUnlockShareId,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 获取岛屿解锁成功分享ID
GetIslandShareIdHttp = xClass("GetIslandShareIdHttp", HttpBase)
GetIslandShareIdHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getIslandSuccShareId,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 获取岛屿解锁成功分享奖励
GetIslandShareRewardHttp = xClass("GetIslandShareRewardHttp", HttpBase)
GetIslandShareRewardHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getIslandShareReward,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}


// 获取岛屿满星成功分享奖励
GetIslandFullShareRewardHttp = xClass("GetIslandFullShareRewardHttp", HttpBase)
GetIslandFullShareRewardHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.fullStarShareReward,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// 获取关前道具看广告信息
PropsBeforeLevelAdHttp = xClass("PropsBeforeLevelAdHttp", HttpBase)
PropsBeforeLevelAdHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.propsBeforeLevelAd,
        {},
        buildCallback(this), rpc.SendingPriority.kHigh, true)
}

// AI礼包-获取每日特惠礼包
// 关末礼包获取也是这个接口
AIGetDailyPackageHttp = xClass("AIGetDailyPackageHttp", HttpBase)
AIGetDailyPackageHttp.prototype.load = function (param) {
    let self = this
    self.request(kHttpEndPoints.getAiGiftBagInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// AI礼包-检查礼包购买资格
AICheckCanByPackageHttp = xClass("AICheckCanByPackageHttp", HttpBase)
AICheckCanByPackageHttp.prototype.load = function (packageId, pkgType) {
    let self = this
    self.request(kHttpEndPoints.checkAiGiftBagBuy, { giftBagId: packageId, giftBagType: pkgType }, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// AI礼包-获取分组信息
AIGetGroupTestHttp = xClass("AIGetGroupTestHttp", HttpBase)
AIGetGroupTestHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getAiGroupTestInfo, {}, buildCallback(self), rpc.SendingPriority.kHigh, false);
}

// AI礼包-收集玩家ai礼包实时特征值
AICollectUserInfoHttp = xClass("AICollectUserInfoHttp", HttpBase)
AICollectUserInfoHttp.prototype.load = function (param) {
    let self = this
    self.request(kHttpEndPoints.gatherUserAiInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 领取回归奖励
FetchBackRewardHttp = xClass("FetchBackRewardHttp", HttpBase)
FetchBackRewardHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.fetchBackReward, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 道具广告
GetAdGambleInfoHttp = xClass("GetAdGambleInfoHttp", HttpBase)
GetAdGambleInfoHttp.prototype.load = function (uid) {
    let self = this
    self.request(kHttpEndPoints.getAdGambleInfo,
        { uid: uid },
        buildCallback(self), rpc.SendingPriority.kHigh, true);
}

AdGambleDrawHttp = xClass("AdGambleDrawHttp", HttpBase)
AdGambleDrawHttp.prototype.load = function (uid) {
    let self = this
    self.request(kHttpEndPoints.adGambleDraw,
        { uid: uid },
        buildCallback(self), rpc.SendingPriority.kHigh, true);
}

GetAdGambleRewardHttp = xClass("GetAdGambleRewardHttp", HttpBase)
GetAdGambleRewardHttp.prototype.load = function (uid) {
    let self = this
    self.request(kHttpEndPoints.getAdGambleReward,
        { uid: uid },
        buildCallback(self), rpc.SendingPriority.kHigh, true);
}

SaveGoldModeAdHttp = xClass("SaveGoldModeAdHttp", HttpBase)
SaveGoldModeAdHttp.prototype.load = function (uid) {
    let self = this
    self.request(kHttpEndPoints.saveGoldModeAd,
        { uid: uid },
        buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 存钱罐
// 获取存钱罐信息
PiggyBankGetInfoHttp = xClass("PiggyBankGetInfoHttp", HttpBase)
PiggyBankGetInfoHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getMoneyBoxInfo, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 获取存钱罐信息
PiggyBankCheckMoneyBoxByHttp = xClass("PiggyBankCheckMoneyBoxByHttp", HttpBase)
PiggyBankCheckMoneyBoxByHttp.prototype.load = function (id) {
    let self = this
    self.request(kHttpEndPoints.checkMoneyBoxBuy, { id: id }, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 获取存钱罐取消订单
PiggyBankMoneyBoxCancelHttp = xClass("PiggyBankMoneyBoxCancelHttp", HttpBase)
PiggyBankMoneyBoxCancelHttp.prototype.load = function (id) {
    let self = this
    self.request(kHttpEndPoints.moneyBoxCancel, { moneyBoxId: id }, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 获取存钱罐ProductId
PiggyBankGetMoneyBoxProductIdlHttp = xClass("PiggyBankGetMoneyBoxProductIdlHttp", HttpBase) 
PiggyBankGetMoneyBoxProductIdlHttp.prototype.load = function(id) {
    let self = this
    self.request(kHttpEndPoints.getMoneyBoxProductId, {id:id}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 获取存钱罐查询正在进行中的订单是否完成
QueryOrderStateHttp = xClass("QueryOrderStateHttp", HttpBase)
QueryOrderStateHttp.prototype.load = function (orderId) {
    let self = this
    self.request(kHttpEndPoints.queryOrder, { orderId: orderId }, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

QueryThirdPartyOrderHttp = xClass("QueryThirdPartyOrderHttp", HttpBase)
QueryThirdPartyOrderHttp.prototype.load = function (orderList) {
    let self = this
    self.request(kHttpEndPoints.queryThirdPartyOrder, { orderList: orderList }, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


// 获取海岛满星奖励
IslandGetFullStarRewardsHttp = xClass("IslandGetFullStarRewardsHttp", HttpBase)
IslandGetFullStarRewardsHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.getIslandRewards, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 领取取海岛满星奖励
IslandFetchFullStarRewardsHttp = xClass("IslandFetchFullStarRewardsHttp", HttpBase)
IslandFetchFullStarRewardsHttp.prototype.load = function (islandId) {
    let self = this
    self.request(kHttpEndPoints.fetchIslandRewards, { islandId: islandId }, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//玩吧下单校验
WanbaCheckOrderHttp = xClass("WanbaCheckOrderHttp", HttpBase) 
WanbaCheckOrderHttp.prototype.load = function() {
    let self = this
    self.request(kHttpEndPoints.wanbaCheckOrder, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


// 获取海滨之星活动信息
SeasideStarInfosHttp = xClass("SeasideStarInfosHttp", HttpBase)
SeasideStarInfosHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.coastStarInfo, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 获取海滨之星排行榜列表
SeasideStarRankHttp = xClass("SeasideStarRankHttp", HttpBase)
SeasideStarRankHttp.prototype.load = function (type) {
    let self = this
    self.request(kHttpEndPoints.coastStarRank, { type: type }, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 海滨之星领取进度奖励
SeasideStarFetchRewardHttp = xClass("SeasideStarFetchRewardHttp", HttpBase)
SeasideStarFetchRewardHttp.prototype.load = function (index) {
    let self = this
    self.request(kHttpEndPoints.coastStarFetchReward, { index: index }, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 海滨之星翻倍奖励
SeasideStarBonusHttp = xClass("SeasideStarBonusHttp", HttpBase)
SeasideStarBonusHttp.prototype.load = function (type, collectionNum, sessionId) {
    let self = this
    let param = {
        type: type,
        collectionNum: collectionNum,
        sessionId: sessionId
    }
    self.request(kHttpEndPoints.coastStarBonus, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 海滨之星获取分享id
SeasideStarGetShareIdHttp = xClass("SeasideStarGetShareIdHttp", HttpBase)
SeasideStarGetShareIdHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.coastStarGetShareId, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 海滨之星点击分享链接
SeasideStarShareClickHttp = xClass("SeasideStarShareClickHttp", HttpBase)
SeasideStarShareClickHttp.prototype.load = function (inviteCode, shareId) {
    let self = this
    let param = {
        inviteCode: inviteCode,
        shareId: shareId
    }
    self.request(kHttpEndPoints.coastStarShareClick, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 精力广告
EnergyAdInfoHttp = xClass("EnergyAdInfoHttp", HttpBase)
EnergyAdInfoHttp.prototype.load = function (type) {
    let self = this
    let param = {
        type: type
    }
    self.request(kHttpEndPoints.getAdInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 关前开始按钮广告
StartAdInfoHttp = xClass("StartAdInfoHttp", HttpBase)
StartAdInfoHttp.prototype.load = function (type, levelId) {
    let self = this
    let param = {
        type: type,
        levelId: levelId
    }
    self.request(kHttpEndPoints.getAdInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//冠军赛获取信息接口
ChampionInfoHttp = xClass("ChampionInfoHttp", HttpBase)
ChampionInfoHttp.prototype.load = function (openActPanel, autoJoin) {
    let self = this
    let param = {
        openActPanel: openActPanel,
        autoJoin: autoJoin
    }
    self.request(kHttpEndPoints.championInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//冠军赛领奖接口
ChampionRewardFetchHttp = xClass("ChampionRewardFetchHttp", HttpBase)
ChampionRewardFetchHttp.prototype.load = function (type) {
    let self = this
    let param = {
        type: type
    }
    self.request(kHttpEndPoints.championRewardFetch, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 获取广告
GetAdInfoHttp = xClass("GetAdInfoHttp", HttpBase)
GetAdInfoHttp.prototype.load = function (data) {
    let self = this
    let param = data || {}
    self.request(kHttpEndPoints.getAdInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 领取每日免费补星道具
FetchFillStarRewardHttp = xClass("FetchFillStarRewardHttp", HttpBase)
FetchFillStarRewardHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.fetchFillStarReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//广告任务获取信息接口
AdTaskInfoHttp = xClass("AdTaskInfoHttp", HttpBase)
AdTaskInfoHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.getAdTaskInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//广告任务领奖接口
AdTaskRewardFetchHttp = xClass("AdTaskRewardFetchHttp", HttpBase)
AdTaskRewardFetchHttp.prototype.load = function (index) {
    let self = this
    let param = {
        index: index
    }
    self.request(kHttpEndPoints.fetchAdTaskReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//获取最新精力信息
// GetEnergyHttp = xClass("AdTaskRewardFetchHttp", HttpBase) 
// GetEnergyHttp.prototype.load = function() {
//     let self = this
//     let param = {}
//     self.request(kHttpEndPoints.getEnergy, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
// }

//通行证获取信息接口
BattlePassInfoHttp = xClass("BattlePassInfoHttp", HttpBase)
BattlePassInfoHttp.prototype.load = function (endFlag) {
    let self = this
    let param = {
        endFlag: endFlag || false
    }
    self.request(kHttpEndPoints.battlePassInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//通行证领奖接口
BattlePassRewardFetchHttp = xClass("BattlePassRewardFetchHttp", HttpBase)
BattlePassRewardFetchHttp.prototype.load = function (type, nodeId) {
    let self = this
    let param = {
        type: type,
        nodeId: nodeId
    }
    self.request(kHttpEndPoints.battlePassRewardFetch, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//限时闯关获取信息接口
RushLimitInfoHttp = xClass("RushLimitInfoHttp", HttpBase)
RushLimitInfoHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.rushLimitInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//限时闯关 报名
RushLimitJoinHttp = xClass("RushLimitJoinHttp", HttpBase)
RushLimitJoinHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.rushLimitJoin, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//限时闯关 领奖
RushLimitRewardFetchHttp = xClass("RushLimitRewardFetchHttp", HttpBase)
RushLimitRewardFetchHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.rushLimitRewardFetch, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//限时闯关 触发机器人成长
RushLimitRobotGrowFetchHttp = xClass("RushLimitRobotGrowFetchHttp", HttpBase)
RushLimitRobotGrowFetchHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.rushLimitRobotGrow, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//限时闯关 获取分享id
RushLimitGetShareIdHttp = xClass("RushLimitGetShareIdHttp", HttpBase)
RushLimitGetShareIdHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.rushLimitGetShareId, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//限时闯关 点击分享链接
RushLimitShareClickHttp = xClass("RushLimitShareClickHttp", HttpBase)
RushLimitShareClickHttp.prototype.load = function (inviteCode, shareId) {
    let self = this
    let param = {
        inviteCode: inviteCode,
        shareId: shareId
    }
    self.request(kHttpEndPoints.rushLimitShareClick, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//新手任务获取信息接口
GetNewUserTaskInfoHttp = xClass("GetNewUserTaskInfoHttp", HttpBase)
GetNewUserTaskInfoHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.getNewUserTaskInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 新手任务触发完成
FinishNewUserTaskHttp = xClass("FinishNewUserTaskHttp", HttpBase)
FinishNewUserTaskHttp.prototype.load = function (id) {
    let self = this
    let param = {
        id: id
    }
    self.request(kHttpEndPoints.finishNewUserTask, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 新手任务触发完成
FetchNewUserTaskRewardHttp = xClass("FetchNewUserTaskRewardHttp", HttpBase)
FetchNewUserTaskRewardHttp.prototype.load = function (id) {
    let self = this
    let param = {
        id: id
    }
    self.request(kHttpEndPoints.fetchNewUserTaskReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// // 难度干预用户数据存储用
SaveDAUserDataV2Http = xClass("SaveDAUserDataV2Http", HttpBase)
SaveDAUserDataV2Http.prototype.load = function (text, time) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    let params = table([1, "data", text], [1, "requestTime", Localhost.timeInSec()])
    self.request(kHttpEndPoints.updateDropData, params, loadCallback, rpc.SendingPriority.kHigh, false)
}
// 难度干预用户数据存拉取
GetDAUserDataV2Http = xClass("GetDAUserDataV2Http", HttpBase)
GetDAUserDataV2Http.prototype.load = function () {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            context.onLoadingError(err)
        } else {
            context.onLoadingComplete(data)
        }
    }
    let params = table()
    self.request(kHttpEndPoints.getDropData, params, loadCallback, rpc.SendingPriority.kHigh, false)
}

// cube
CubeAbTestHttp = xClass("CubeAbTestHttp", HttpBase)
CubeAbTestHttp.prototype.load = function (param) {
    let self = this
    self.request(kHttpEndPoints.cubeAbTest, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


//周年庆获取信息接口
ShardCollectInfoHttp = xClass("ShardCollectInfoHttp", HttpBase)
ShardCollectInfoHttp.prototype.load = function () {
    let self = this

    self.request(kHttpEndPoints.anniversaryInfo, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//周年庆预约接口
ShardCollectReserveHttp = xClass("ShardCollectReserveHttp", HttpBase)
ShardCollectReserveHttp.prototype.load = function () {
    let self = this

    self.request(kHttpEndPoints.anniversaryWarmUp, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//周年庆领奖接口
ShardCollectFetchRewardHttp = xClass("ShardCollectFetchRewardHttp", HttpBase)
ShardCollectFetchRewardHttp.prototype.load = function (type, pieceId, giftBagId, nodeId) {
    let self = this
    let param = {
        type: type,
        giftBagId: giftBagId,
        pieceId: pieceId,
        nodeId : nodeId
    }
    self.request(kHttpEndPoints.anniversaryFetchReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//周年庆合成奖券接口
ShardCollectExchangeLotteryHttp = xClass("ShardCollectExchangeLotteryHttp", HttpBase)
ShardCollectExchangeLotteryHttp.prototype.load = function ( prizeId) {
    let self = this
    let param = {
        prizeId: prizeId
    }
    self.request(kHttpEndPoints.anniversaryExchangeLottery, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// //周年庆passinfo接口
// ShardCollectPassInfoHttp = xClass("ShardCollectPassInfoHttp", HttpBase)
// ShardCollectPassInfoHttp.prototype.load = function ( ) {
//     let self = this
//     let param = {
//     }
//     self.request(kHttpEndPoints.anniversaryBattlePassInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
// }
//周年庆兑换实物道具接口
ShardCollectExchangeHttp = xClass("ShardCollectExchangeHttp", HttpBase)
ShardCollectExchangeHttp.prototype.load = function (prizeId) {
    let self = this
    let param = {
        prizeId: prizeId
    }
    self.request(kHttpEndPoints.anniversaryExchangeReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//周年庆填地址接口
ShardCollectAddressHttp = xClass("ShardCollectAddressHttp", HttpBase)
ShardCollectAddressHttp.prototype.load = function (actId, contact) {
    let self = this
    let param = {
        contact: contact,
        actId: actId
    }
    self.request(kHttpEndPoints.addContactInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//周年庆兑换记录接口
ShardCollectExchangeRecordHttp = xClass("ShardCollectExchangeRecordHttp", HttpBase)
ShardCollectExchangeRecordHttp.prototype.load = function () {
    let self = this

    self.request(kHttpEndPoints.anniversaryExchangeRecord, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 神秘商店获取信息接口
GetSecretShopInfoHttp = xClass("GetSecretShopInfoHttp", HttpBase)
GetSecretShopInfoHttp.prototype.load = function (openPanel) {
    let self = this
    self.request(kHttpEndPoints.getSecretShopInfo, { openPanel: openPanel }, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 神秘商店选择折扣接口
ChooseSecretShopDiscountHttp = xClass("ChooseSecretShopDiscountHttp", HttpBase)
ChooseSecretShopDiscountHttp.prototype.load = function () {
    let self = this
    self.request(kHttpEndPoints.chooseSecretShopDiscount, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 神秘商店检查支付接口
CheckSecretShopBuyHttp = xClass("CheckSecretShopBuyHttp", HttpBase)
CheckSecretShopBuyHttp.prototype.load = function (id) {
    let self = this
    self.request(kHttpEndPoints.checkSecretShopBuy, { id: id }, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//造船获取信息接口
BuildShipInfoHttp = xClass("BuildShipInfoHttp", HttpBase)
BuildShipInfoHttp.prototype.load = function () {
    let self = this

    self.request(kHttpEndPoints.shipDetailLite, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//造船获取详细信息接口
BuildShipDetailHttp = xClass("BuildShipDetailHttp", HttpBase)
BuildShipDetailHttp.prototype.load = function () {
    let self = this

    self.request(kHttpEndPoints.shipDetail, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//造船新手引导步骤完成接口
BuildShipGuideHttp = xClass("BuildShipGuideHttp", HttpBase)
BuildShipGuideHttp.prototype.load = function (newbieGuideStep) {
    let self = this
    let param = {
        newbieGuideStep
    }
    self.request(kHttpEndPoints.shipNewbieGuideStep, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//造船获取全国排行榜接口
BuildShipRankHttp = xClass("BuildShipRankHttp", HttpBase)
BuildShipRankHttp.prototype.load = function (start, end) {
    let self = this
    let param = {
        start,
        end
    }
    self.request(kHttpEndPoints.shipGlobalRank, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//造船领取全国排行榜奖励接口
BuildShipRankRewardHttp = xClass("BuildShipRankRewardHttp", HttpBase)
BuildShipRankRewardHttp.prototype.load = function () {
    let self = this

    self.request(kHttpEndPoints.shipGlobalRankRewardFetch, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//造船领取昨日船长奖励接口
BuildShipCaptainRewardHttp = xClass("BuildShipCaptainRewardHttp", HttpBase)
BuildShipCaptainRewardHttp.prototype.load = function () {
    let self = this

    self.request(kHttpEndPoints.shipCaptainRewardFetch, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//造船获取宝箱奖励接口
BuildShipBoxRewardHttp = xClass("BuildShipBoxRewardHttp", HttpBase)
BuildShipBoxRewardHttp.prototype.load = function () {
    let self = this

    self.request(kHttpEndPoints.shipChestRewardFetch, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//造船复活小组成员接口
BuildShipCoinReviveHttp = xClass("BuildShipCoinReviveHttp", HttpBase)
BuildShipCoinReviveHttp.prototype.load = function (uid) {
    let self = this
    let param = {
        targetUid: uid
    }
    self.request(kHttpEndPoints.shipMemberRevive, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//造船复活通知接口
BuildShipReviveNoticeHttp = xClass("BuildShipReviveNoticeHttp", HttpBase)
BuildShipReviveNoticeHttp.prototype.load = function (uid) {
    let self = this
    self.request(kHttpEndPoints.shipMemberReviveNotice, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


//造船看广告复活自己接口
BuildShipAdReviveHttp = xClass("BuildShipAdReviveHttp", HttpBase)
BuildShipAdReviveHttp.prototype.load = function () {
    let self = this

    self.request(kHttpEndPoints.shipAdRevive, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//造船准备开始收集部件接口
BuildShipReadyStartHttp = xClass("BuildShipReadyStartHttp", HttpBase)
BuildShipReadyStartHttp.prototype.load = function (unitId) {
    let self = this
    let param = {
        unitId: unitId
    }
    self.request(kHttpEndPoints.shipCollectUnitReady, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


//晋级赛info
QualifyingInfoHttp = xClass("QualifyingInfoHttp", HttpBase)
QualifyingInfoHttp.prototype.load = function (openPanel) {
    let self = this
    let param = {
        openPanel: openPanel || false
    }
    self.request(kHttpEndPoints.qualifyingInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//晋级赛加入小组
QualifyingJoinHttp = xClass("QualifyingJoinHttp", HttpBase)
QualifyingJoinHttp.prototype.load = function () {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.qualifyingJoin, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//晋级赛获取分享id
QualifyingGetShareIdHttp = xClass("QualifyingGetShareIdHttp", HttpBase)
QualifyingGetShareIdHttp.prototype.load = function () {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.qualifyingGetShareId, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//晋级赛点击链接进入
QualifyingShareClickHttp = xClass("QualifyingShareClickHttp", HttpBase)
QualifyingShareClickHttp.prototype.load = function (inviteCode, shareId) {
    let self = this
    let param = {
        inviteCode: inviteCode,
        shareId: shareId
    }
    self.request(kHttpEndPoints.qualifyingShareClick, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//晋级赛看广告获取翻倍卡
QualifyingWatchAdHttp = xClass("QualifyingWatchAdHttp", HttpBase)
QualifyingWatchAdHttp.prototype.load = function () {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.qualifyingWatchAd, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//晋级赛领取每日奖励
QualifyingFetchRewardHttp = xClass("QualifyingFetchRewardHttp", HttpBase)
QualifyingFetchRewardHttp.prototype.load = function (type) {
    let self = this
    let param = {
        type: type
    }
    self.request(kHttpEndPoints.qualifyingFetchReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

QualifyingGuideHttp = xClass("QualifyingGuideHttp", HttpBase)
QualifyingGuideHttp.prototype.load = function () {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.qualifyingGuide, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//星岛info
StarDreamInfoHttp = xClass("StarDreamInfoHttp", HttpBase)
StarDreamInfoHttp.prototype.load = function () {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.starDreamInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//星岛领奖
StarDreamRewardHttp = xClass("StarDreamRewardHttp", HttpBase)
StarDreamRewardHttp.prototype.load = function (type, indexList) {
    let self = this
    let param = {
        type: type,
        indexList: indexList
    }
    self.request(kHttpEndPoints.starDreamFetchReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//星岛看广告
StarDreamWatchAdHttp = xClass("StarDreamWatchAdHttp", HttpBase)
StarDreamWatchAdHttp.prototype.load = function (count) {
    let self = this
    let param = {
        count: count
    }
    self.request(kHttpEndPoints.starDreamWatchAd, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


//星岛锻造星石
StarDreamBuildHttp = xClass("StarDreamBuildHttp", HttpBase)
StarDreamBuildHttp.prototype.load = function (count) {
    let self = this
    let param = {
        count: count
    }
    self.request(kHttpEndPoints.starDreamBuild, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//星岛分享信息
StarDreamShareInfoHttp = xClass("StarDreamShareInfoHttp", HttpBase)
StarDreamShareInfoHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.starDreamShareInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


//星岛点击分享icon
StarDreamingShareClickHttp = xClass("StarDreamingShareClickHttp", HttpBase)
StarDreamingShareClickHttp.prototype.load = function (inviteCode, shareId) {
    let self = this
    let param = {
        inviteCode: inviteCode,
        shareId: shareId
    }
    self.request(kHttpEndPoints.starDreamShareClick, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//星岛获得分享id
StarDreamingShareIdHttp = xClass("StarDreamingShareIdHttp", HttpBase)
StarDreamingShareIdHttp.prototype.load = function () {
    let self = this
    let param = {

    }
    self.request(kHttpEndPoints.starDreamGetShareId, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//微信礼包检查
GetWxGiftHttp = xClass("GetWxGiftHttp", HttpBase)
GetWxGiftHttp.prototype.load = function () {
    let self = this
    let param = {

    }
    self.request(kHttpEndPoints.getWxGift, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//cdkey  兑换码进行兑换
GetCdKeyRewardHttp = xClass("GetCdKeyRewardHttp", HttpBase)
GetCdKeyRewardHttp.prototype.load = function (cdKey) {
    let self = this
    let param = {
        cdKey: cdKey
    }
    // 增加了os字段
    if (cc.sys.os === cc.sys.OS_IOS) {
        param.os = 2;
    } else if (cc.sys.os === cc.sys.OS_ANDROID) {
        param.os = 1;
    }
    self.request(kHttpEndPoints.getCdKeyReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 新手奖励领取接口
FetchNoviceGiftHttp = xClass("FetchNoviceGiftHttp", HttpBase)
FetchNoviceGiftHttp.prototype.load = function () {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.beginnerGiftFetchReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//无尽宝箱info接口
GetEndlessTreasureInfoHttp = xClass("GetEndlessTreasureInfoHttp", HttpBase)
GetEndlessTreasureInfoHttp.prototype.load = function () {
    let self = this;
    self.request(kHttpEndPoints.getEndlessTreasureInfo,
        {},
        buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//无尽宝箱领取接口
GetEndlessTreasureFetchHttp = xClass("GetEndlessTreasureFetchHttp", HttpBase)
GetEndlessTreasureFetchHttp.prototype.load = function () {
    let self = this;
    self.request(kHttpEndPoints.getEndlessTreasureFetchReward,
        {},
        buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//主线收集活动info
LevelCollectionInfoHttp = xClass("LevelCollectionInfoHttp", HttpBase) 
LevelCollectionInfoHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.levelCollectionInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//获取快艇大赛活动信息
SpeedboatMatchInfoHttp = xClass("SpeedboatMatchInfoHttp", HttpBase)
SpeedboatMatchInfoHttp.prototype.load = function () {
    let self = this;
    self.request(kHttpEndPoints.speedboatMatchInfo,
        {},
        buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//参与快艇大赛活动
SpeedboatMatchJoinHttp = xClass("SpeedboatMatchJoinHttp", HttpBase)
SpeedboatMatchJoinHttp.prototype.load = function () {
    let self = this;
    self.request(kHttpEndPoints.speedboatMatchJoin,
        {},
        buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//参与快艇领取奖励
SpeedboatMatchRewardFetch = xClass("SpeedboatMatchRewardFetch", HttpBase)
SpeedboatMatchRewardFetch.prototype.load = function () {
    let self = this;
    self.request(kHttpEndPoints.speedboatMatchRewardFetch,
        {},
        buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//月票info
MonthCardInfoHttp = xClass("MonthCardInfoHttp", HttpBase) 
MonthCardInfoHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.monthCardInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//月票领取奖励
MonthCardFetchRewardHttp = xClass("MonthCardFetchRewardHttp", HttpBase) 
MonthCardFetchRewardHttp.prototype.load = function(type) {
    let self = this
    let param = {
        type: type
    }
    self.request(kHttpEndPoints.monthCardFetchReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 新版商城info
ShopInfoHttp = xClass("ShopInfoHttp", HttpBase) 
ShopInfoHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.shopInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 新版商城 免费领取奖励
ShopFreeBuyHttp = xClass("ShopFreeBuyHttp", HttpBase) 
ShopFreeBuyHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.shopFreeBuy, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 新版商城 主动刷新
ShopRefreshHttp = xClass("ShopRefreshHttp", HttpBase) 
ShopRefreshHttp.prototype.load = function(mode,module,requestTime) {
    let self = this
    let param = {
        mode:mode,
        module:module,
    }
    if (requestTime) param.requestTime = requestTime
    self.request(kHttpEndPoints.shopRefresh, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//海岛礼包
IslandTreasureInfoHttp = xClass("IslandTreasureInfoHttp", HttpBase) 
IslandTreasureInfoHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.islandTreasureInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//海岛礼包领取奖励
IslandTreasureFetchRewardHttp = xClass("IslandTreasureFetchRewardHttp", HttpBase) 
IslandTreasureFetchRewardHttp.prototype.load = function(islandId) {
    let self = this
    let param = {
        islandId: islandId
    }
    self.request(kHttpEndPoints.islandTreasureFetchReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


// 抖音侧边栏提醒
DouyinSideRewardsDetailHttp = xClass("DouyinSideRewardsDetailHttp", HttpBase) 
DouyinSideRewardsDetailHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.douyinSideRewardsDetail, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 抖音侧边栏复访奖励
DouyinSideRewardsFetchHttp = xClass("DouyinSideRewardsFetchHttp", HttpBase) 
DouyinSideRewardsFetchHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.douyinSideRewardsFetch, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 抖音侧边栏复访奖励
DouyinRecommendCardRewardFetchHttp = xClass("DouyinRecommendCardRewardFetchHttp", HttpBase) 
DouyinRecommendCardRewardFetchHttp.prototype.load = function(cardId) {
    let self = this
    let param = {
        cardId:cardId
    }
    self.request(kHttpEndPoints.douyinRecommendCardRewardFetch, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//贴贴获取info
StickerBattleInfoHttp = xClass("StickerBattleInfoHttp", HttpBase) 
StickerBattleInfoHttp.prototype.load = function(openPanel) {
    let self = this
    let param = {
        openPanel: openPanel
    }
    self.request(kHttpEndPoints.stickerBattleInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

StickerBattleJoinHttp = xClass("StickerBattleJoinHttp", HttpBase) 
StickerBattleJoinHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.stickerBattleJoin, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

StickerBattleBookHttp = xClass("StickerBattleBookHttp", HttpBase) 
StickerBattleBookHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.stickerBattleBook, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//贴贴获取info (new)
OceanPartyInfoHttp = xClass("OceanPartyInfoHttp", HttpBase) 
OceanPartyInfoHttp.prototype.load = function(openPanel) {
    let self = this
    let param = {
        openPanel: openPanel
    }
    self.request(kHttpEndPoints.oceanPartyInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

OceanPartyFetchRewardHttp = xClass("OceanPartyFetchRewardHttp", HttpBase) 
OceanPartyFetchRewardHttp.prototype.load = function() {
    let self = this
    let param = {
      
    }
    self.request(kHttpEndPoints.oceanPartyFetchReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

GetUserProfileInfoHttp = xClass("GetUserProfileInfoHttp", HttpBase) 
GetUserProfileInfoHttp.prototype.load = function(uidList) {
    let self = this
    let param = {
        uidList: uidList
    }
    self.request(kHttpEndPoints.getUserProfileInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


// 摘椰子-获取活动详情
BalloonRiseDetailHttp = xClass("BalloonRiseDetailHttp", HttpBase) 
BalloonRiseDetailHttp.prototype.load = function(showDetailPanel) {
    let self = this
    let param = {
        showDetailPanel,
    }
    self.request(kHttpEndPoints.balloonRiseDetail, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 摘椰子-节点奖励领取
BalloonRiseNodeRewardFetchHttp = xClass("BalloonRiseNodeRewardFetchHttp", HttpBase) 
BalloonRiseNodeRewardFetchHttp.prototype.load = function(gradeId, nodeId, abilityId) {
    let self = this
    let param = {
        gradeId,
        nodeId,
        abilityId,
    }
    self.request(kHttpEndPoints.balloonRiseNodeRewardFetch, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 精力礼包信息
EnergyPackInfoHttp = xClass("EnergyPackInfoHttp", HttpBase) 
EnergyPackInfoHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.energyPackInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 金币乐园
GoldElysiumInfoHttp = xClass("GoldElysiumInfoHttp", HttpBase) 
GoldElysiumInfoHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.goldElysiumInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//获取钓鱼活动信息
FishingInfoHttp = xClass("FishingInfoHttp", HttpBase) 
FishingInfoHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.fishingInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//参加钓鱼活动比赛
FishingJoinHttp = xClass("FishingJoinHttp", HttpBase) 
FishingJoinHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.fishingJoin, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//钓鱼活动抛竿
FishingCastHttp = xClass("FishingCastHttp", HttpBase) 
FishingCastHttp.prototype.load = function(rodId, fishNum,adFlag,guideFlag) {
    let self = this
    let param = {rodId, fishNum, adFlag, guideFlag}
    self.request(kHttpEndPoints.fishingCast, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//钓鱼活动分享链接
FishingGetShareIdHttp = xClass("FishingGetShareIdHttp", HttpBase) 
FishingGetShareIdHttp.prototype.load = function(fishId) {
    let self = this
    let param = {fishId}
    self.request(kHttpEndPoints.fishingGetShareId, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//钓鱼活动点击分享链接
FishingShareClickHttp = xClass("FishingShareClickHttp", HttpBase) 
FishingShareClickHttp.prototype.load = function(inviteCode, shareId, fishId) {
    let self = this
    let param = {inviteCode, shareId, fishId}
    self.request(kHttpEndPoints.fishingShareClick, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//钓鱼活动领取奖励
FishingFetchRewardHttp = xClass("FishingFetchRewardHttp", HttpBase) 
FishingFetchRewardHttp.prototype.load = function(type) {
    let self = this
    let param = {type}
    self.request(kHttpEndPoints.fishingFetchReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//钓鱼达人引导
FishingGuideHttp = xClass("FishingGuideHttp", HttpBase) 
FishingGuideHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.fishingGuide, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//限定礼包
LiveGiftInfoHttp = xClass("LiveGiftInfoHttp", HttpBase) 
LiveGiftInfoHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.getLiveGiftBagInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}


// 装扮信息
GetDressInfoHttp = xClass("GetDressInfoHttp", HttpBase) 
GetDressInfoHttp.prototype.load = function(type) {
    let self = this
    let param = {
        type: type
    }
    self.request(kHttpEndPoints.getDressInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//通行证banner曝光
BattlePassBannerShowHttp = xClass("BattlePassBannerShowHttp", HttpBase) 
BattlePassBannerShowHttp.prototype.load = function(endFlag) {
    let self = this
    let param = {endFlag}
    self.request(kHttpEndPoints.battlePassBannerShow, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//通行证banner信息
BattlePassBannerInfoHttp = xClass("BattlePassBannerInfoHttp", HttpBase) 
BattlePassBannerInfoHttp.prototype.load = function(endFlag) {
    let self = this
    let param = {endFlag}
    self.request(kHttpEndPoints.battlePassBannerInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//获取关卡分数排行信息
GetLevelScoreRankInfoHttp = xClass("GetLevelScoreRankInfoHttp", HttpBase) 
GetLevelScoreRankInfoHttp.prototype.load = function(levelId) {
    let self = this
    let param = {levelId}
    self.request(kHttpEndPoints.getLevelScoreRankInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//获取关卡分数排行榜
GetLevelScoreRankListHttp = xClass("GetLevelScoreRankListHttp", HttpBase) 
GetLevelScoreRankListHttp.prototype.load = function(levelId) {
    let self = this
    let param = {levelId}
    self.request(kHttpEndPoints.getLevelScoreRankList, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//周榜
WeekRankDetailHttp = xClass("WeekRankDetailHttp", HttpBase) 
WeekRankDetailHttp.prototype.load = function(weekType, rankType, regionType) {
    let self = this
    let param = {weekType, rankType, regionType}
    self.request(kHttpEndPoints.weekRankDetail, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//周榜-榜单列表
WeekRankListHttp = xClass("WeekRankListHttp", HttpBase) 
WeekRankListHttp.prototype.load = function(weekType, rankType, regionType) {
    let self = this
    let param = {weekType, rankType, regionType}
    self.request(kHttpEndPoints.weekRankList, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

WeekRankRewardFetchHttp = xClass("WeekRankRewardFetchHttp", HttpBase) 
WeekRankRewardFetchHttp.prototype.load = function(rankType) {
    let self = this
    let param = {rankType}
    self.request(kHttpEndPoints.weekRankRewardFetch, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

WeekRankCupListHttp = xClass("WeekRankCupListHttp", HttpBase) 
WeekRankCupListHttp.prototype.load = function(rankType, targetUid) {
    let self = this
    let param = {targetUid, rankType}
    self.request(kHttpEndPoints.weekRankCupList, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//解码特工-活动详情
MagicCodeDetailHttp = xClass("MagicCodeDetailHttp", HttpBase) 
MagicCodeDetailHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.magicCodeDetail, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

MagicCodePlayHttp = xClass("MagicCodePlayHttp", HttpBase) 
MagicCodePlayHttp.prototype.load = function(tryCipher, buyCipherFlag, payUnitNum) {
    let self = this
    let param = {tryCipher, buyCipherFlag, payUnitNum}
    self.request(kHttpEndPoints.magicCodePlay, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

MagicCodeSettleRewardFetchHttp = xClass("MagicCodeSettleRewardFetchHttp", HttpBase) 
MagicCodeSettleRewardFetchHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.magicCodeSettleRewardFetch, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

GetUserScoreInfoHttp = xClass("GetUserScoreInfoHttp", HttpBase) 
GetUserScoreInfoHttp.prototype.load = function(levelIds) {
    let self = this
    let param = {}
    if (levelIds)param.levelIds = levelIds
    self.request(kHttpEndPoints.getUserScoreInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//马戏团
CircusGameInfoHttp = xClass("CircusGameInfoHttp", HttpBase) 
CircusGameInfoHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.circusInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

CircusGameSpinHttp = xClass("CircusGameSpinHttp", HttpBase) 
CircusGameSpinHttp.prototype.load = function(spinType) {
    let self = this
    let param = {
        spinType : spinType
    }
    self.request(kHttpEndPoints.circusSpin, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//挖宝石
CoffeeLotCookingInfoHttp = xClass("CoffeeLotCookingInfoHttp", HttpBase) 
CoffeeLotCookingInfoHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.coffeeLotCookingInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

CoffeeLotCookingShovelHttp = xClass("CoffeeLotCookingShovelHttp", HttpBase) 
CoffeeLotCookingShovelHttp.prototype.load = function(row, col, type) {
    let self = this
    let param = {
        row, col, type
    }
    self.request(kHttpEndPoints.coffeeLotCookingShovel, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

// 春节礼包购买校验
CheckSpringPackBuyHttp = xClass("CheckSpringPackBuyHttp", HttpBase)
CheckSpringPackBuyHttp.prototype.load = function (id) {
    let self = this
    self.request(kHttpEndPoints.checkSpringPackBuy, { id: id }, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//投篮王牌获取信息接口
DunkAceInfoHttp = xClass("DunkAceInfoHttp", HttpBase)
DunkAceInfoHttp.prototype.load = function (showDetailPanel) {
    let self = this
    let param = {
        showDetailPanel
    }
    self.request(kHttpEndPoints.dunkAceDetail, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//投篮王牌报名参赛接口
DunkAceJoinHttp = xClass("DunkAceJoinHttp", HttpBase)
DunkAceJoinHttp.prototype.load = function () {
    let self = this

    self.request(kHttpEndPoints.dunkAceJoin, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//投篮王牌领奖接口
DunkAceFetchRewardHttp = xClass("DunkAceFetchRewardHttp", HttpBase)
DunkAceFetchRewardHttp.prototype.load = function () {
    let self = this

    self.request(kHttpEndPoints.dunkAceRewardFetch, {}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//关卡崩溃上报接口
LevelCrashHttp = xClass("LevelCrashHttp", HttpBase)
LevelCrashHttp.prototype.load = function (levelId, requestTime) {
    let self = this

    self.request(kHttpEndPoints.levelCrash, {levelId, requestTime}, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//水上乐斗-活动详情
WaterFightingDetailHttp = xClass("WaterFightingDetailHttp", HttpBase) 
WaterFightingDetailHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.waterFightingDetail, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

WaterFightingJoinHttp = xClass("WaterFightingJoinHttp", HttpBase) 
WaterFightingJoinHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.waterFightingJoin, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

WaterFightingRewardFetchHttp = xClass("WaterFightingRewardFetchHttp", HttpBase) 
WaterFightingRewardFetchHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.waterFightingRewardFetch, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

WaterFightingRecordsHttp = xClass("WaterFightingRecordsHttp", HttpBase) 
WaterFightingRecordsHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.waterFightingRecords, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

WaterFightingHpRecoverHttp = xClass("WaterFightingHpRecoverHttp", HttpBase) 
WaterFightingHpRecoverHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.waterFightingHpRecover, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//三选一礼包-获取活动详情
TrinityGiftBagDetailHttp = xClass("TrinityGiftBagDetailHttp", HttpBase) 
TrinityGiftBagDetailHttp.prototype.load = function() {
    let self = this
    let param = {}
    self.request(kHttpEndPoints.trinityGiftBagDetail, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

TrinityGiftBagBuyCheckHttp = xClass("TrinityGiftBagBuyCheckHttp", HttpBase) 
TrinityGiftBagBuyCheckHttp.prototype.load = function(giftBagId) {
    let self = this
    let param = {giftBagId}
    self.request(kHttpEndPoints.trinityGiftBagBuyCheck, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//超鸟
SuperMagicBirdInfoHttp = xClass("SuperMagicBirdInfoHttp", HttpBase) 
SuperMagicBirdInfoHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.superMagicBirdInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

SuperMagicBirdGuideHttp = xClass("SuperMagicBirdGuideHttp", HttpBase) 
SuperMagicBirdGuideHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.superMagicBirdGuide, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

SuperMagicBirdLevelPanelGuideHttp = xClass("SuperMagicBirdLevelPanelGuideHttp", HttpBase) 
SuperMagicBirdLevelPanelGuideHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.superMagicBirdLevelPanelGuide, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//信件
MailListHttp = xClass("MailListHttp", HttpBase) 
MailListHttp.prototype.load = function(showMailIds) {
    let self = this
    let param = {showMailIds}
    self.request(kHttpEndPoints.mailList, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

MailOpenHttp = xClass("MailOpenHttp", HttpBase) 
MailOpenHttp.prototype.load = function(mailId) {
    let self = this
    let param = {mailId}
    self.request(kHttpEndPoints.mailOpen, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

MailAcceptHttp = xClass("MailAcceptHttp", HttpBase) 
MailAcceptHttp.prototype.load = function(mailId) {
    let self = this
    let param = {mailId}
    self.request(kHttpEndPoints.mailAccept, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

MailDeleteHttp = xClass("MailDeleteHttp", HttpBase) 
MailDeleteHttp.prototype.load = function(mailId) {
    let self = this
    let param = {mailId}
    self.request(kHttpEndPoints.mailDelete, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

MailBatchDeleteHttp = xClass("MailBatchDeleteHttp", HttpBase) 
MailBatchDeleteHttp.prototype.load = function(mailTypes) {
    let self = this
    let param = {mailTypes}
    self.request(kHttpEndPoints.mailBatchDelete, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

MailBatchAcceptHttp = xClass("MailBatchAcceptHttp", HttpBase) 
MailBatchAcceptHttp.prototype.load = function(mailTypes) {
    let self = this
    let param = {mailTypes}
    self.request(kHttpEndPoints.mailBatchAccept, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//俄罗斯方块
TetrisInfoHttp = xClass("TetrisInfoHttp", HttpBase)
TetrisInfoHttp.prototype.load = function (gameReady) {
    let self = this
    let param = {
        gameReady
    }
    self.request(kHttpEndPoints.tetrisDetail, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
TetrisLevelUpHttp = xClass("TetrisLevelUpHttp", HttpBase)
TetrisLevelUpHttp.prototype.load = function (newLevelId) {
    let self = this
    let param = {
        newLevelId
    }
    self.request(kHttpEndPoints.tetrisLevelUp, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
TetrisFetchRewardHttp = xClass("TetrisFetchRewardHttp", HttpBase)
TetrisFetchRewardHttp.prototype.load = function () {
    let self = this
    let param = {
        
    }
    self.request(kHttpEndPoints.tetrisSettle, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

//救援礼包
SalvageGiftBagDetailHttp = xClass("SalvageGiftBagDetailHttp", HttpBase) 
SalvageGiftBagDetailHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.salvageGiftBagDetail, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
SalvageGiftBagShowHttp = xClass("SalvageGiftBagShowHttp", HttpBase) 
SalvageGiftBagShowHttp.prototype.load = function(showType, devicePerformance) {
    let self = this
    let param = {showType, devicePerformance}
    self.request(kHttpEndPoints.salvageGiftBagShow, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

SalvageGiftBagBuyCheckHttp = xClass("SalvageGiftBagBuyCheckHttp", HttpBase) 
SalvageGiftBagBuyCheckHttp.prototype.load = function(giftBagId) {
    let self = this
    let param = {giftBagId}
    self.request(kHttpEndPoints.salvageGiftBagBuyCheck, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

SalvageGiftBagRewardFetchHttp = xClass("SalvageGiftBagRewardFetchHttp", HttpBase) 
SalvageGiftBagRewardFetchHttp.prototype.load = function(useFlag) {
    let self = this
    let param = {useFlag}
    self.request(kHttpEndPoints.salvageGiftBagRewardFetch, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
// 宠物
PetStoryInfoHttp = xClass("PetStoryInfoHttp", HttpBase) 
PetStoryInfoHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.petStoryInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
PetStoryPetInfoHttp = xClass("PetStoryPetInfoHttp", HttpBase) 
PetStoryPetInfoHttp.prototype.load = function(id) {
    let self = this
    let param = {
        id: id
    }
    self.request(kHttpEndPoints.petStoryPetInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

PetStoryJoinHttp = xClass("PetStoryJoinHttp", HttpBase) 
PetStoryJoinHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.petStoryJoin, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

PetStoryShareInfoHttp = xClass("PetStoryShareInfoHttp", HttpBase) 
PetStoryShareInfoHttp.prototype.load = function(id) {
    let self = this
    let param = {
        id: id
    }
    self.request(kHttpEndPoints.petStoryShareInfo, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

PetStoryInviteHttp = xClass("PetStoryInviteHttp", HttpBase) 
PetStoryInviteHttp.prototype.load = function(id, type, inviteUid) {
    let self = this
    let param = {
        id: id,
        type: type,
        inviteUid: inviteUid,
    }
    self.request(kHttpEndPoints.petStoryInvite, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
PetStoryWalkHttp = xClass("PetStoryWalkHttp", HttpBase) 
PetStoryWalkHttp.prototype.load = function(id, m, partnerGrowthValue) {
    let self = this
    let param = {
        id: id,
        m: m,
        partnerGrowthValue: partnerGrowthValue
    }
    self.request(kHttpEndPoints.petStoryWalk, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

PetStorySkipGuideHttp = xClass("PetStorySkipGuideHttp", HttpBase) 
PetStorySkipGuideHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.petStorySkipGuide, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
PetStoryFetchRewardHttp = xClass("PetStoryFetchRewardHttp", HttpBase) 
PetStoryFetchRewardHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.petStoryFetchReward, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

PetStoryGetShareIdHttp = xClass("PetStoryGetShareIdHttp", HttpBase) 
PetStoryGetShareIdHttp.prototype.load = function() {
    let self = this
    let param = {
    }
    self.request(kHttpEndPoints.petStoryGetShareId, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

PetStoryShareClickHttp = xClass("PetStoryShareClickHttp", HttpBase) 
PetStoryShareClickHttp.prototype.load = function(inviteCode, shareId) {
    let self = this
    let param = {
        inviteCode: inviteCode,
        shareId: shareId,
    }
    self.request(kHttpEndPoints.petStoryShareClick, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
//个人信息面板点赞
UserProfileLikeHttp = xClass("UserProfileLikeHttp", HttpBase) 
UserProfileLikeHttp.prototype.load = function(targetUid) {
    let self = this
    let param = {targetUid}
    self.request(kHttpEndPoints.userProfileLike, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}

UserProfileShowHttp = xClass("UserProfileShowHttp", HttpBase) 
UserProfileShowHttp.prototype.load = function(targetUid) {
    let self = this
    let param = {targetUid}
    self.request(kHttpEndPoints.userProfileShow, param, buildCallback(self), rpc.SendingPriority.kHigh, true);
}
